<template>
  <div class="teacher">
    <el-tabs class="px-2" v-model="activeName" type="card">
      <el-tab-pane label="基础信息" name="basic">
    <!-- <icon-menu></icon-menu> -->
    <div class="mb-3 pl-2 teacher-filter-panel">
      <div class="d-flex align-items-center justify-content-end mb-2 teacher-filter-row">
        <span class="mr-2" style="font-size: 14px; color: #606266;">当前数据日期</span>
        <el-date-picker
          v-model="currentYear"
          type="year"
          placeholder="选择年份"
          size="small"
          style="width: 120px"
          value-format="yyyy">
        </el-date-picker>
      </div>
      <el-radio-group v-if="user.role !== 7" v-model="tabType" size="small" class="teacher-tab-group">
        <el-radio-button label="all">全量讲师</el-radio-button>
        <el-radio-button v-if="user.role !== 7" label="new_signed">新签约讲师情况</el-radio-button>
        <el-radio-button v-if="user.role !== 7" label="progress">新讲师签约进度</el-radio-button>
      </el-radio-group>
    </div>

    <!-- Statistics Layer -->
    <div class="stats-container mb-3 pl-2" v-loading="statsLoading" v-if="statsData && statsData.length && user.role !== 7">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, index) in statsData" :key="index">
          <el-card shadow="hover" :body-style="{ padding: '15px' }" 
            @click.native="handleStatsClick(item, index)"
            :class="{'stats-card-active': activeStatsIndex === index, 'stats-card': true}">
            <div class="d-flex align-items-center">
              <div class="stats-icon mr-3" :class="item.color ? 'text-' + item.color : 'text-primary'">
                  <i :class="getIcon(item.icon)" style="font-size: 32px;"></i>
                </div>
                <div class="stats-info">
                  <div class="text-secondary fs-12 mb-1">{{ item.label }}</div>
                  <div class="fs-20 font-weight-bold mb-1" :class="{'text-danger': item.color === 'danger'}">
                    {{ formatValue(item) }} <span class="fs-12 text-muted">{{ item.unit }}</span>
                  </div>
                </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 新增：本年度未成单讲师数量统计 -->
        <el-col :span="6" v-if="tabType === 'all' && user.role !== 7">
          <el-card shadow="hover" :body-style="{ padding: '15px' }"
            @click.native="handleNoOrderStatsClick"
            :class="{'stats-card-active': activeStatsIndex === 'no_order', 'stats-card': true}">
            <div class="d-flex align-items-center">
              <div class="stats-icon mr-3 text-warning">
                <i class="el-icon-warning-outline" style="font-size: 32px;"></i>
              </div>
              <div class="stats-info" style="flex: 1; min-width: 0;">
                <div class="text-secondary fs-12 mb-1 d-flex justify-content-between align-items-center">
                  <span>本年度未成单讲师数量</span>
                </div>
                <el-skeleton v-if="noOrderLoading" :rows="1" animated />
                <el-alert v-else-if="noOrderError" type="error" title="加载失败" show-icon :closable="false" style="padding: 0; line-height: 1.2;"></el-alert>
                <div v-else class="fs-20 font-weight-bold mb-1">
                  {{ noOrderTeacherCount !== null ? noOrderTeacherCount : '-' }} <span class="fs-12 text-muted">人</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6" v-if="tabType === 'all' && user.role !== 7">
          <el-card shadow="never" :body-style="{ padding: '12px 15px' }" class="stats-card stats-card-static monthly-amount-card">
            <div class="d-flex align-items-center monthly-amount-card__content">
              <div class="stats-icon mr-3 text-primary">
                <i class="el-icon-tickets" style="font-size: 32px;"></i>
              </div>
              <div class="stats-info monthly-amount-card__info">
                <div class="monthly-amount-card__header">
                  <span class="text-secondary fs-12">月度交付金额</span>
                  <el-select v-model="deliveryStatMonth" size="mini" class="monthly-amount-card__select">
                    <el-option
                      v-for="item in monthlyStatMonthOptions"
                      :key="'delivery-' + item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
                <div class="monthly-amount-card__value">
                  {{ getMonthlyStatAmount('delivery', deliveryStatMonth) }} <span class="fs-12 text-muted">元</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6" v-if="tabType === 'all' && user.role !== 7">
          <el-card shadow="never" :body-style="{ padding: '12px 15px' }" class="stats-card stats-card-static monthly-amount-card">
            <div class="d-flex align-items-center monthly-amount-card__content">
              <div class="stats-icon mr-3 text-primary">
                <i class="el-icon-money" style="font-size: 32px;"></i>
              </div>
              <div class="stats-info monthly-amount-card__info">
                <div class="monthly-amount-card__header">
                  <span class="text-secondary fs-12">月度销售金额</span>
                  <el-select v-model="salesStatMonth" size="mini" class="monthly-amount-card__select">
                    <el-option
                      v-for="item in monthlyStatMonthOptions"
                      :key="'sales-' + item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
                <div class="monthly-amount-card__value">
                  {{ getMonthlyStatAmount('sales', salesStatMonth) }} <span class="fs-12 text-muted">元</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="d-flex teacher-toolbar">
      <import class="pl-2 teacher-toolbar-import" :doImport="doImport" :parseItems="parseItems"></import>
      <div class="ml-3 mb-3 teacher-toolbar-item" v-if="[0, 1, 4, 5].includes(user.role)">
        <el-button size="small" type="success" plain @click="exportImgs">导出讲师培训图片</el-button>
      </div>

      <div class="ml-3 mb-3 teacher-toolbar-item" v-if="[0, 1, 4, 5].includes(user.role)">
        <el-button v-if="[0, 1, 4, 5].includes(user.role)" type="success" plain
          @click="exportTeachs">导出讲师授课记录</el-button>
      </div>

      <!-- <div class="pl-3" v-if="(user.username = 'admin')">
        <span class="pr-2 pl-2 fs-9 import-ex">导出讲师排课数据</span>
        <el-button type="primary" @click="exprot">导出</el-button>
      </div> -->
    </div>

    <div class="px-2 mb-3 teacher-search-panel">
      <el-form :model="listFilters" size="small" label-width="80px" class="teacher-search-form">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="讲师姓名">
              <el-input
                v-model.trim="listFilters.name"
                clearable
                placeholder="请输入"
                @keyup.enter.native="applyListFilters"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="签约日期">
              <el-date-picker
                v-model="listFilters.contractDate"
                type="daterange"
                clearable
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="选择开始日期"
                end-placeholder="选择结束日期"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="授课领域">
              <el-select v-model="listFilters.field" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in teacherFieldOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="常驻城市">
              <el-input
                v-model.trim="listFilters.resident_city"
                clearable
                placeholder="请输入"
                @keyup.enter.native="applyListFilters"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="最高学历">
              <el-select v-model="listFilters.educational" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in teacherEducationalOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="等级">
              <el-select v-model="listFilters.grade" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in teacherGradeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="合作属性">
              <el-select v-model="listFilters.teacher_type" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in teacherTypeOptions"
                  :key="`teacher-type-${item.value}`"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="师资负责人">
              <el-select v-model="listFilters.user" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in principalUserOptions"
                  :key="item._id"
                  :label="item.realname"
                  :value="item._id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" class="teacher-search-actions-col">
            <div class="teacher-search-actions">
              <el-button type="primary" icon="el-icon-search" class="teacher-search-btn" @click="applyListFilters">搜索</el-button>
              <el-button icon="el-icon-delete" class="teacher-reset-btn" @click="resetListFilters">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="px-2 mb-3 teacher-toolbar-bottom">
      <el-button v-if="[0, 1, 4, 5].includes(user.role)" type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增</el-button>
    </div>

    <avue-crud ref="crud" :key="`${useDefaultFields ? 'default' : 'rank'}-${isMobile ? 'mobile' : 'desktop'}`" :data="data.data" :option="crudOption" v-model="crudForm" @row-save="create" @row-update="update"
      @row-del="remove" :page.sync="page" @on-load="changPage" @sort-change="handleRankSortChange" :upload-preview="preview"
      :before-open="beforeOpen" :before-close="beforeClose" :table-loading="tableLoading">
<template slot-scope="scope" slot="menu">
        <el-button
          v-if="user.role == 0 || (user.role == 5 && permission === 'me')"
          icon="iconfont icon-fenpei1"
          @click="distribution(scope)"
          type="text"
          >指派负责人</el-button
        >
        <el-button
          v-if="user.role == 0 || (user.role == 5 && permission === 'me')"
          icon="el-icon-remove-outline"
          @click="removeUser(scope)"
          type="text"
          >解除负责人</el-button
        >
        <el-button
          v-if="(user.role == 0 || user.role == 6 || user.role == 10 || isRowPrincipal(scope.row)) && user.role !== 7"
          icon="el-icon-edit"
          @click="handleRowEdit(scope)"
          type="text"
          >编辑</el-button>
        <el-button v-if="user.role !== 7" @click="teacherData(scope.row)" icon="el-icon-document" type="text">数据详情</el-button>

        <el-button v-if="user.role !== 7" @click="teachData(scope.row)" icon="el-icon-document" type="text">授课记录</el-button>
      </template>
      <template slot="userForm" slot-scope="{}">
        <div class="teacher-user-display">{{ formatPrincipalName(normalizePrincipalValue(crudForm.user)) }}</div>
      </template>
      <template slot="is_publicForm" slot-scope="{ disabled }">
        <!-- 用 :value + @change 而非 v-model：存量讲师库里没有 is_public 键，而 avue 关闭弹窗时
             会把表单对象的键全部 $delete 掉，编辑该讲师时该键可能确实不存在——Vue 2 下往不存在的
             键写值不触发响应，勾了看不到变化，故写回走 handlePublicChange 里的 $set。
             @change 回传的是 true-label/false-label，即数字 1/0，与接口白名单口径(is_public===1)一致 -->
        <el-checkbox
          :value="Number(crudForm.is_public) === 1"
          :disabled="disabled || crudReadonly"
          @change="handlePublicChange"
        >官网公开</el-checkbox>
      </template>
      <template slot="courseOutlineForm" slot-scope="{}">
        <div style="min-height: 400px;">
             <FileList
               v-if="embeddedFormsReady && crudForm._id"
               type="outline"
               :teacher-id="crudForm._id"
               :readonly="photoReadonly"
             />
        </div>
      </template>
      <template slot="typesForm" slot-scope="{ disabled }">
        <el-cascader
          v-model="typesFormValue"
          :options="teacherTypeTreeOptions"
          :props="teacherTypesProps"
          :disabled="disabled || crudReadonly"
          clearable
          collapse-tags
          style="width: 100%;"
          @change="handleTeacherTypesChange"
        />
      </template>
      <template slot="fieldForm" slot-scope="{ disabled }">
        <el-select v-model="crudForm.field" :disabled="disabled || crudReadonly" filterable clearable multiple placeholder="请选择授课领域" style="width: 100%;">
          <el-option
            v-for="item in teacherFieldOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </template>
      <template slot="educationalForm" slot-scope="{ disabled }">
        <el-select v-model="crudForm.educational" :disabled="disabled || crudReadonly" filterable clearable style="width: 100%;">
          <el-option
            v-for="item in teacherEducationalOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </template>
      <template slot="teacher_typeForm" slot-scope="{ disabled }">
        <el-select v-model="crudForm.teacher_type" :disabled="disabled || crudReadonly" filterable clearable style="width: 100%;">
          <el-option
            v-for="item in teacherTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </template>
      <template slot="trainingPhotosForm" slot-scope="scope">
        <div style="min-height: 400px;">
             <div v-if="[0, 1, 4, 5].includes(user.role)" class="mb-2">
               <el-button
                 size="small"
                 type="success"
                 plain
                 @click="batchDownloadTeachingPhotos"
               >批量下载</el-button>
             </div>
             <div v-if="showPhotos && photos.length > 0" class="mb-3">
               <div class="label-title">培训图片:</div>
               <el-timeline>
                 <el-timeline-item
                   v-for="(item, index) in photos"
                   :key="index"
                   :timestamp="'终端客户：' + item.terminal_name + ' 日期：' + $filters.formatDateT(item.times)"
                   placement="top">
                   <el-card>
                     <el-image
                       class="mx-1"
                       v-for="img in item.url"
                       :key="img"
                       style="width: 102px; height: 102px"
                       :src="getOssUrl(img)"
                       fit="cover"
                       :preview-src-list="item.url">
                     </el-image>
                   </el-card>
                 </el-timeline-item>
               </el-timeline>
             </div>
             <TeachingPhotos
               v-if="embeddedFormsReady && scope.row._id"
               :value="crudForm.trainingPhotos"
               :teacher-id="scope.row._id"
               :readonly="photoReadonly"
               @input="updateTrainingPhotos"
               @success="loadTrainingPhotos"
             />
        </div>
      </template>
      <template slot="teachingVideoForm" slot-scope="{}">
        <FileList
          v-if="embeddedFormsReady && crudForm._id"
          type="video"
          :teacher-id="crudForm._id"
          :readonly="photoReadonly"
          :is-new-teacher="isNewTeacherForm"
          style="min-height: 400px;"
        />
      </template>
      <template slot="publicPhotosForm" slot-scope="{}">
        <PublicPhotos
          v-if="embeddedFormsReady && crudForm._id"
          :teacher-id="crudForm._id"
          :readonly="photoReadonly"
        />
      </template>
    </avue-crud>
      </el-tab-pane>
      <el-tab-pane v-if="user.role !== 7" label="合同管理" name="contract">
        <teacher-contract-list v-if="activeName === 'contract'"></teacher-contract-list>
      </el-tab-pane>
      <el-tab-pane v-if="user.role !== 7" label="文件文档管理" name="files">
        <teacher-file-list v-if="activeName === 'files'"></teacher-file-list>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="obj.name" :visible.sync="dialogVisible" width="80%" align="center" :before-close="handleClose">
      <div class="text-right mb-3 d-flex align-items-center teacher-dialog-filter">
        <span class="mr-2 fs-9 ml-auto">当前数据年月份</span>
        <div style="width: 270px">
          <el-date-picker style="width: 100% !important" v-model="customerQuery.year" type="monthrange"
            :clearable="false" value-format="yyyy-MM-dd" placeholder="请选择年月份" />
        </div>
      </div>
      <div class="mb-4">
        <avue-data-panel :option="teacherOption"></avue-data-panel>
      </div>
      <div class="d-flex chart-box">
        <div ref="chart1" class="chart1" style="height: 280px; width: 100%"></div>
        <!-- <div ref="chart2" class="chart2" style="height: 280px; width: 100%"></div> -->
      </div>
      <div class="d-flex">
        <!-- <div ref="chart4" style="height: 280px; width: 100%"></div> -->
      </div>
      <div class="w-100">
        <div ref="chart3" style="height: 280px; width: 100%"></div>
      </div>
      <div class="fs-16 d-flex mt-2">合作机构排名</div>
      <el-table class="mt-3" :data="customers" stripe border style="width: 100%">
        <el-table-column prop="_id.name" label="机构名称">
          <template slot-scope="{ row }">
            <span v-if="row.customer">{{ row.customer.name }}</span>
            <span v-else>客户已删除</span>
          </template>
        </el-table-column>
        <el-table-column prop="days" label="线下授课/天"> </el-table-column>
        <el-table-column prop="hour" label="线上授课/小时"> </el-table-column>
      </el-table>

      <div class="mt-3">
        <el-pagination background @current-change="handleCurrentChange" :current-page.sync="customerQuery.page"
          layout="total, prev, pager, next" :total="customerPage.total">
        </el-pagination>
      </div>

      <div class="detail_table">
        <div class="fs-16 d-flex mt-2">回款明细</div>
        <el-table class="mt-3" :data="detailData" stripe border @sort-change="sortDetailData" style="width: 100%">
          <el-table-column prop="_id.name" label="机构名称" width="300">
            <template slot-scope="{ row }">
              <span v-if="row.customer">{{ row.customer.name }}</span>
              <span v-else>客户已删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="post" label="档期名称"> </el-table-column>
          <el-table-column prop="user" label="经纪人" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.user">{{ row.user.realname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_amount" sortable="custom" label="总金额" width="100">
          </el-table-column>
          <el-table-column prop="received" sortable="custom" label="已回款" width="100">
          </el-table-column>
          <el-table-column prop="remain" sortable="custom" label="未回款" width="100">
          </el-table-column>
        </el-table>
      </div>

      <div class="mt-3">
        <el-pagination background @current-change="changeDetailPage" :current-page.sync="detailPage.page"
          layout="total, prev, pager, next" :total="detailPage.total">
        </el-pagination>
      </div>

      <div class="mt-4">
        <div class="fs-16 mb-3 text-left" style="text-align: left;">银行合作数据分析</div>
        <div class="d-flex chart-box">
           <div class="chart-wrapper" style="width: 50%; border: 1px solid #eee; padding: 10px; margin-right: 10px;">
             <div class="text-center mb-2">线上</div>
             <div ref="bankOnlineChart" class="chart1" style="height: 300px; width: 100%"></div>
           </div>
           <div class="chart-wrapper" style="width: 50%; border: 1px solid #eee; padding: 10px;">
             <div class="text-center mb-2">线下</div>
             <div ref="bankOfflineChart" class="chart2" style="height: 300px; width: 100%"></div>
           </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="fs-16 mb-3 text-left" style="text-align: left;">讲师合作省份数据分析</div>
        <div class="d-flex chart-box">
           <div class="chart-wrapper" style="width: 50%; border: 1px solid #eee; padding: 10px; margin-right: 10px;">
             <div class="text-center mb-2">线上</div>
             <div ref="provinceOnlineChart" class="chart1" style="height: 300px; width: 100%"></div>
           </div>
           <div class="chart-wrapper" style="width: 50%; border: 1px solid #eee; padding: 10px;">
             <div class="text-center mb-2">线下</div>
             <div ref="provinceOfflineChart" class="chart2" style="height: 300px; width: 100%"></div>
           </div>
        </div>
      </div>

      <!-- <div>
        <div class="fs-16 d-flex mt-2">未回款明细</div>
        <el-table
          class="mt-3"
          :data="customers"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column prop="_id.name" label="机构名称">
            <template slot-scope="{ row }">
              <span v-if="row.customer">{{ row.customer.name }}</span>
              <span v-else>客户已删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="days" label="线下授课/天"> </el-table-column>
          <el-table-column prop="hour" label="线上授课/小时"> </el-table-column>
        </el-table>
      </div> -->
    </el-dialog>

    <el-dialog title="导出培训图片" :visible.sync="dialogExport" width="30%" :before-close="handleClose">
     
   <avue-form v-model="exportForm" :option="exportOption" @submit="exportSubmit">
        <template #teacherIds="{ disabled }">
          <div>
            <MultipleSelect :disabled="disabled" filterable :selectOptions="teachers_options"
              v-model="exportForm.teacherIds" ref="multipleSelectImg" />
          </div>
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog title="导出授课记录" :visible.sync="teachExport" width="50%" :before-close="closeTeach">
      <avue-form v-model="teachForm" :option="teachExportOption" @submit="teachSubmit">
        <template #teachers="{ disabled }">
          <div>
            <MultipleSelect :disabled="disabled" filterable :selectOptions="teachers_options"
              v-model="teachForm.teachers" ref="multipleSelect" />
          </div>
        </template>
      </avue-form>
    </el-dialog>

    <el-dialog title="授课记录" :visible.sync="isShowTeach" width="90%" :before-close="handleTeacherClose">
      <div style="height: 900px">
        <avue-crud v-model="teachQuery" :table-loading="teachLoading" :data="teachList" :option="teachoption"
          :page.sync="teachPage" @search-change="teachSearch" @on-load="changTeachPage" @sort-change="sortChange"
          style="height: 100px">
          <template slot="menuRight">
            <div v-loading="teachLoading" class="h6">
              全年满意度 <span class="font-bold mx-2">{{ year_evaluate }}%</span>
            </div>
          </template>
          <template slot="timesSearch">
            <el-date-picker v-model="queryTimes" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </template>

          <template slot="citySearch">
            <el-cascader :options="cityOptions" v-model="queryCitys" :props="{ checkStrictly: true }"
              clearable></el-cascader>
          </template>

          <template slot="city" slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.city && scope.row.city.join(' | ')" placement="top">
              <div class="text-truncate1">{{ scope.row.city && scope.row.city.join(" | ") }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope" slot="times">
            <el-popover placement="top-start" trigger="hover" slot="reference">
              <div style="max-width: 400px">
                {{ cur_time(scope.row) | formatDateT }}
              </div>
              <div slot="reference">
                <div class="text-truncate cursor-pointer" style="width: 100px">
                  {{ cur_time(scope.row) | formatDateT }}
                </div>
              </div>
            </el-popover>
          </template>
          <template slot="terminal_name" slot-scope="scope">
            <el-tooltip effect="dark" :content="_.get(scope.row, 'terminal_name')" placement="top-start">
              <div class="text-truncate cursor-pointer">
                {{ _.get(scope.row, "terminal_name") }}
              </div>
            </el-tooltip>
          </template>
          <template slot="customer" slot-scope="scope">
            <el-tooltip effect="dark" :content="_.get(scope.row, 'customer')" placement="top-start">
              <div class="text-truncate cursor-pointer">
                {{ _.get(scope.row, "customer") }}
              </div>
            </el-tooltip>
          </template>

          <template slot="student_job" slot-scope="scope">
            <el-tooltip effect="dark" :content="_.get(scope.row, 'student_job')" placement="top-start">
              <div class="text-truncate cursor-pointer">
                {{ _.get(scope.row, "student_job") }}
              </div>
            </el-tooltip>
          </template>
          <template slot="post" slot-scope="scope">
            <el-tooltip effect="dark" :content="_.get(scope.row, 'post')" placement="top-start">
              <div class="text-truncate cursor-pointer">
                {{ _.get(scope.row, "post") }}
              </div>
            </el-tooltip>
          </template>

          <template slot-scope="scope" slot="way">
            <el-tag :type="scope.row.way == 0 ? 'primary' : 'success'">
              {{ scope.row.way == 0 ? "线上" : "线下" }}</el-tag>
          </template>

          <template slot-scope="scope" slot="fate">
            <span v-if="scope.row.way == 1"> {{ scope.row.fate }} 天</span>
            <span v-else> {{ scope.row.hour }} 小时</span>
          </template>
        </avue-crud>
      </div>
    </el-dialog>

    <el-dialog
      title="分配负责人"
      :visible.sync="dialogPrincipal"
      width="30%"
      :before-close="handlePrincipalClose"
    >
      <div>
        <avue-form
          v-if="dialogPrincipal"
          v-model="principalForm"
          :option="dialogOption"
          @submit="submit"
        ></avue-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as dayjs from "dayjs";
  import JSZip from "jszip";
  import { saveAs } from "file-saver";
  import { saver } from "../../plugins/saver";

  import TeacherContractList from './TeacherContractList.vue';
  import TeacherFileList from './TeacherFileList.vue';
  import FileList from "../../components/fileList.vue";
  import TeachingPhotos from "../../components/TeachingPhotos.vue";
  import PublicPhotos from "../../components/PublicPhotos.vue";

export default {
  components: {
    TeacherContractList,
    TeacherFileList,
    FileList,
    TeachingPhotos,
    PublicPhotos
  },
  data() {
      const validEmail = (rule, value, callback) => {
        const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱"));
        }
      };
      const currentMonth = String(dayjs().month() + 1);
      const monthlyStatMonthOptions = Array.from({ length: 12 }, (_, index) => {
        const month = String(index + 1);
        return {
          label: `${month}月份`,
          value: month,
        };
      });
      return {
        activeName: 'basic',
        statsData: [],
        statsLoading: false,
        activeStatsIndex: -1,
        statsFilter: null,
        useDefaultFields: true,
        isMobile: false,
        tabType: 'all',
        currentYear: new Date().getFullYear() + '',
        noOrderTeacherCount: null,
        noOrderLoading: false,
        noOrderError: false,
        monthlyStatMonthOptions,
        deliveryStatMonth: currentMonth,
        salesStatMonth: currentMonth,
        monthlyStatAmountMap: {},
        listFilters: {
          name: "",
          grade: "",
          field: "",
          teacher_type: "",
          resident_city: "",
          educational: "",
          user: "",
          contractDate: [],
        },
        crudOption: {},
        teacherOption: {},
        cityOptions: [],
        dialogExport: false,
        teachExport: false,
        teachForm: {
          times: [],
          teachers: [],
        },
        exportForm: {
          teacherIds: [],
        },
        photoReadonly: false,
        crudReadonly: false,
        isShowTeach: false,
        teachList: [],
        teacheQuery: {},
        customerCount: null,
        userData: null,
        teachingDay: null,
        dialogVisible: false,
        tabs: true,
        teachersId: null,
        recommendData: null,
        form: {},
        showPhotos: false,
        embeddedFormsReady: false,
        isNewTeacherForm: false,
        teacherTypeTreeOptions: [],
        typesFormValue: [],
        teacherTypesProps: {
          multiple: true,
          emitPath: true,
          label: "label",
          value: "label",
        },
        crudForm: {
          field: [],
          quotation: [],
          trainingPhotos: [],
        },
        dialogPrincipal: false,
        principalForm: {
          _id: "",
          name: "",
          user: [],
        },
        obj: {
          quotation: [
            {
              title: "公开课对外报价",
              unit: "元/6小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "内训课对外报价",
              unit: "元/6小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "半天课对外报价",
              unit: "元/3小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "1.5天课对外报价",
              unit: "元/9小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "直播课对外报价",
              unit: "元/1小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "直播课对外报价",
              unit: "元/6小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "录播课对外报价",
              unit: "元/1小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "异地直播课报价",
              unit: "元/1小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "异地直播课报价",
              unit: "元/6小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "异地录播课报价",
              unit: "元/1小时",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "线上微沙龙报价",
              unit: "元/1场次",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "线下微沙龙报价",
              unit: "元/1场次",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "辅导项目报价",
              unit: "元/天",
              amount: 0,
              terminal_price: 0,
            },
            {
              title: "其他类别报价",
              unit: "",
              amount: 0,
              terminal_price: 0,
            },
          ],
          // training_photos: [],
          trainingPhotos: [],
        },

        exportOption: {
          translate: false,
          column: [
            {
              label: "选择讲师",
              prop: "teacherIds",
              type: "select",
              slot: true,
              span: 24,
              props: {
                label: "name",
                value: "_id",
              },
              multiple: true,
              all: true,
              dicUrl: `teachers/option`,
              filterable: true,
              rules: [
                {
                  required: true,
                  message: "请选择导出的内容",
                  trigger: "blur",
                },
              ],
            },
            // {
            //   label: "邮箱",
            //   prop: "email",
            //   slot: true,
            //   rules: [
            //     {
            //       required: true,
            //       message: "请填写邮箱",
            //       trigger: "blur",
            //     },
            //     { validator: validEmail, trigger: "blur", required: true },
            //   ],
            // },
          ],
        },
        teachExportOption: {
          translate: false,
          column: [
            {
              label: "选择讲师",
              prop: "teachers",
              type: "select",
              span: 24,
              props: {
                label: "name",
                value: "_id",
              },
              multiple: true,
              all: true,
              dicUrl: `teachers/option`,
              slot: true,
              filterable: true,
              rules: [
                {
                  required: true,
                  message: "请选择需要导出的讲师",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "选择时间",
              prop: "times",
              type: "daterange",
              startPlaceholder: "开始日期",
              endPlaceholder: "结束日期",
              span: 24,
            },
          ],
        },
        quotation: [
          {
            title: "公开课对外报价",
            unit: "元/6小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "内训课对外报价",
            unit: "元/6小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "半天课对外报价",
            unit: "元/3小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "1.5天课对外报价",
            unit: "元/9小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "直播课对外报价",
            unit: "元/1小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "直播课对外报价",
            unit: "元/6小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "录播课对外报价",
            unit: "元/1小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "异地直播课报价",
            unit: "元/1小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "异地直播课报价",
            unit: "元/6小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "异地录播课报价",
            unit: "元/1小时",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "线上微沙龙报价",
            unit: "元/1场次",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "线下微沙龙报价",
            unit: "元/1场次",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "辅导项目报价",
            unit: "元/天",
            amount: 0,
            terminal_price: 0,
          },
          {
            title: "其他类别报价",
            unit: "",
            amount: 0,
            terminal_price: 0,
          },
        ],
        photos: [],
        year_evaluate: 0,
        importData: [],
        customerQuery: {
          year: [
            dayjs().startOf("year").toDate(),
            dayjs().endOf("month").toDate(),
          ],
          limit: 10,
          page: 1,
        },
        customerPage: {
          total: 0,
        },
        customers: [],
        query: {
          limit: 10,
          page: 1,
          where: {},
          sort: {},
        },
        teachers_options: [],
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        teachPage: {
          total: 0,
          pageSize: 100,
          currentPage: 1,
        },
        teachQuery: {
          where: {},
        },
        teachSort: {
          times: -1,
        },
        teachLoading: false,
        tableLoading: false,
        queryTimes: [],
        queryCitys: [],
        teach_user: {},
        teacherFieldOptions: [],
        teacherEducationalOptions: [],
        teacherGradeOptions: [],
        teacherTypeOptions: [],
        principalUserMap: {},
        principalUserOptions: [],
        data: {
          data: [],
          total: 0,
        },
        showKey: "",
        showDetail: false,
        detailData: [],
        sort_where: {
          order_amount: 1,
          received: 1,
          remain: -1,
        },
        detailPage: {
          page: 1,
          limit: 10,
        },
        bankOnlineOption: null,
        bankOfflineOption: null,
        // receiveddetailPage: {
        //   page: 1,
        //   limit: 10,
        // },
      };
    },
    computed: {
      option() {
        const user = this.$store?.state?.user || {};

        const isHide = [0, 6].includes(user.role);
        const stabilizeEditDialog = true;
        const formatAmount = (value) => `￥${((Number(value) || 0) / 10000).toFixed(2)}`;
        const formatDays = (value) => `${(Number(value) || 0).toFixed(2)}天`;

        const introColumn = [
            {
              label: "讲师姓名",
              prop: "name",
              span: 8,
              width: "100px",
              rules: [
                {
                  required: true,
                  message: "请输入讲师姓名",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "专家定位",
              prop: "expert_positioning",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              // 官网公开开关:勾选后小程序/官网的讲师列表与详情才返回该讲师。
              // 排在专家定位之后 → span 8 正好落在"讲师姓名"这一行的第 3 格(最右)。
              // display 限管理员(role 0):其余角色看不见也改不了(服务端不做角色校验,
              // 但他们的编辑弹窗里不会出现该字段,全量 PUT 仍会原样带上原值,不会误清)
              label: "",
              prop: "is_public",
              formslot: true,
              span: 8,
              labelWidth: 0,
              display: user.role === 0,
              hide: true,
              showColumn: false,
              // 默认值显式给 0:avue 对未声明 value 的 input 列会把表单初值填成 '',
              // 而 '' 经 Mongoose 转 Number 会存成 null(第三种状态)。0 与模型默认值一致,
              // 也与小程序接口的白名单口径(仅 1 对外)对齐
              value: 0,
            },
            {
              label: "专家简介",
              prop: "content",
              type: "input-html",
              span: 24,
              hide: true,
              showColumn: false,
            },
            {
              label: "履历背景",
              prop: "resume_background",
              type: "textarea",
              span: 24,
              minRows: 3,
              hide: true,
              showColumn: false,
            },
            {
              label: "主讲课程",
              prop: "main_courses",
              type: "textarea",
              span: 24,
              minRows: 3,
              hide: true,
              showColumn: false,
            },
            {
              label: "授课风格",
              prop: "teaching_style",
              type: "textarea",
              span: 24,
              minRows: 3,
              hide: true,
              showColumn: false,
            },
            {
              label: "服务客户",
              prop: "service_clients",
              type: "textarea",
              span: 24,
              minRows: 3,
              hide: true,
              showColumn: false,
            },
          ];

        const basicColumn = [
            {
              label: "讲师类型",
              prop: "types",
              formslot: true,
              hide: true,
              span: 8,
            },
            {
              label: "性别",
              prop: "gender",
              props: {
                label: "label",
                value: "label",
              },
              dicUrl: `dictionaries/type/teacher.gender`,
              type: "radio",
              hide: true,
              showColumn: false,
              span: 8,
            },
            {
              label: "手机号",
              prop: "mobile",
              rules: [
                {
                  required: true,
                  message: "请填写手机号",
                  trigger: "blur",
                },
              ],
              search: false,
              span: 8,
              width: "120px",
              showColumn: false,
              hide: true,
            },
            {
              label: "电子邮箱",
              prop: "email",
              hide: true,
              showColumn: false,
              span: 8,
            },
            {
              label: "授课领域",
              search: false,
              prop: "field",
              formslot: true,
              span: 8,
            },
            {
              label: "常驻城市",
              search: false,
              prop: "resident_city",
              span: 8,
              width: "160px",
            },
            {
              label: "最高学历",
              prop: "educational",
              search: false,
              span: 8,
              formslot: true,
              hide: true,
            },
            {
              label: "政治面貌",
              prop: "political_status",
              type: "select",
              dicData: [
                { label: '党员', value: '党员' },
                { label: '群众', value: '群众' }
              ],
              span: 8,
              hide: true,
            },
            {
              label: "是否有职称",
              prop: "has_title",
              type: "radio",
              dicData: [
                { label: '是', value: '是' },
                { label: '否', value: '否' }
              ],
              span: 8,
              hide: true,
            },
            {
              label: "身份证姓名",
              prop: "cardName",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "身份证号码",
              prop: "cardNumber",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "紧急联系人",
              prop: "emergencyContact",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "紧急联系人联系电话",
              prop: "emergencyCall",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "收款账户户名",
              prop: "bankAccountName",
              span: 8,
              hide: true,
            },
            {
              label: "收款账户账号",
              prop: "BankNumber",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "收款账户开户行",
              prop: "bankName",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "特别注意事项",
              prop: "importantReminder",
              type: "textarea",
              span: 24,
              minRows: 2,
              hide: true,
              showColumn: false,
            },
            {
              label: "报备信息",
              prop: "report_info",
              type: "textarea",
              span: 24,
              hide: true,
            },
            {
              label: "学历信息",
              prop: "education_info",
              type: "textarea",
              span: 24,
              hide: true,
            },
            {
              label: "学历证明附件",
              prop: "education_attachment",
              type: "upload",
              loadText: "附件上传中，请稍等",
              span: 18,
              showColumn: false,
              action: "upload",
              accept: ".doc,.docx,.pdf,.png,.jpg,.jpeg,.txt",
            },
            {
              label: "工作信息",
              prop: "work_info",
              type: "textarea",
              span: 24,
              hide: true,
            },
            {
              label: "工作证明附件",
              prop: "attachment",
              type: "upload",
              loadText: "附件上传中，请稍等",
              span: 18,
              showColumn: false,
              action: "upload",
              accept: ".doc,.docx,.pdf,.png,.jpg,.jpeg,.txt",
            },
            {
              label: "身份证照片",
              prop: "cardImage",
              type: "upload",
              dataType: "array",
              listType: "picture-card",
              action: "upload",
              span: 24,
              hide: true,
              showColumn: false,
              multiple: true,
            },
            {
              label: "资质证书照片",
              prop: "certificate",
              multiple: true,
              type: "upload",
              dataType: "array",
              listType: "picture-card",
              action: "upload",
              limit: 999,
              span: 24,
              hide: true,
              showColumn: false,
            },
            {
              label: "讲师头像",
              prop: "avatar",
              multiple: true,
              type: "upload",
              dataType: "array",
              listType: "picture-card",
              action: "upload",
              span: 24,
              hide: true,
              showColumn: false,
            },
            {
              label: "形象照片",
              prop: "photo",
              multiple: true,
              type: "upload",
              dataType: "array",
              listType: "picture-card",
              action: "upload",
              span: 24,
              hide: true,
              showColumn: false,
            },
            // Existing items below
            {
              label: "等级",
              prop: "grade",
              search: false,
              props: {
                label: "label",
                value: "value",
              },
              filterable: true,
              searchFilterable: true,
              width: "60px",
              dicData: this.teacherGradeOptions,
              type: "select",
              // showColumn: false,
              span: 8,
              hide: true,
            },
            {
              label: "线下课酬",
              prop: "price",
              width: "120px",
              type: "number",
              // search: this.IsPC,
              search: false,
              span: 8,
              rules: [
                {
                  required: true,
                  message: "请输入讲师课酬",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "线上课酬",
              prop: "onlinePrice",
              type: "number",
              // search: this.IsPC,
              search: false,
              span: 8,
              rules: [
                {
                  required: true,
                  message: "请输入讲师课酬",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "限时优惠价格",
              prop: "limited_time_price",
              type: "number",
              width: "120px",
              span: 8,
            },
            {
              label: "优惠截止时间",
              prop: "limited_time_end",
              type: "date",
              valueFormat: "yyyy-MM-dd",
              format: "yyyy-MM-dd",
              width: "140px",
              span: 8,
            },
            {
              label: "合作属性",
              search: false,
              prop: "teacher_type",
              formslot: true,
              span: 8,
            },
            {
              label: "负责人",
              prop: "user",
              search: false,
              span: 8,
              formslot: true,
              addDisplay: false,
              editDisplay: false,
            },

            {
              label: "年度目标",
              type: "number",
              prop: "year_target",
              hide: true,
              showColumn: false,
              span: 8,
            },
            {
              label: "年度推荐讲师",
              prop: "recommendedYear",
              type: "radio",
              dicData: [
                { label: '是', value: '是' },
                { label: '否', value: '否' }
              ],
              hide: true,
              showColumn: false,
              span: 8,
            },
            {
              label: "详细地址",
              prop: "address",
              hide: true,
              showColumn: false,
              placeholder: "常住地详细地址(用于邮寄快递等)",
              span: 8,
            },
            {
              label: "毕业院校",
              prop: "industry",
              span: 8,
              hide: true,
              showColumn: false,
            },
            {
              label: "订票信息",
              prop: "bookingInfo",
              type: "textarea",
              span: 24,
              minRows: 2,
              hide: true,
              showColumn: false,
            },
            {
              label: "签约日期",
              prop: "contractDate",
              type: "daterange",
              valueFormat: "yyyy-MM-dd",
              format: "yyyy-MM-dd",
              startPlaceholder: "日期开始范围自定义",
              endPlaceholder: "日期结束范围自定义",
              hide: true,
              showColumn: false,
              span: 24,
            },
            {
              label: "讲师合同",
              prop: "contract",
              multiple: true,
              type: "upload",
              dataType: "array",
              listType: "picture-card",
              action: "upload",
              span: 24,
              hide: true,
              showColumn: false,
              display: false,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
            },
            {
              label: "合同附件",
              prop: "file",
              type: "upload",
              loadText: "附件上传中，请稍等",
              span: 18,
              hide: true,
              showColumn: false,
              action: "upload",
              display: false,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
            },
            {
              label: "讲师海报",
              prop: "poster",
              multiple: true,
              type: "upload",
              dataType: "array",
              listType: "picture-card",
              action: "upload",
              span: 24,
              hide: true,
              showColumn: false,
            },
          ];

        const quoteColumn = [
            {
              label: "讲师报价表",
              prop: "quotation",
              type: "dynamic",
              span: 24,
              hide: true,
              children: {
                align: "center",
                headerAlign: "left",
                rowAdd: (done) => {
                  this.$message.success("新增成功");
                  done({
                    amount: 0,
                    terminal_price: 0,
                  });
                },
                rowDel: (row, done) => {
                  this.$message.success("删除成功");
                  done();
                },
                column: [
                  {
                    width: 200,
                    label: "标题",
                    prop: "title",
                  },
                  {
                    label: "机构报价",
                    type: "number",
                    prop: "amount",
                    controls: true,
                  },
                  {
                    label: "终端报价",
                    type: "number",
                    prop: "terminal_price",
                    disabled: true,
                  },
                  {
                    label: "单位",
                    prop: "unit",
                  },
                ],
              },
            }
        ];

        const listColumn = [
          {
            label: "讲师姓名",
            prop: "name",
            search: false,
            minWidth: 120,
          },
          {
            label: "讲师类型",
            prop: "types_table",
            search: false,
            minWidth: 140,
            formatter: (row) => this.formatListDisplayValue(row.types),
          },
          {
            label: "等级",
            prop: "grade_table",
            search: false,
            minWidth: 90,
            formatter: (row) => this.formatListDisplayValue(row.grade),
          },
          {
            label: "线下课酬",
            prop: "price_table",
            sortable: "custom",
            minWidth: 110,
            formatter: (row) => this.formatTeacherFee(row.price),
          },
          {
            label: "线上课酬",
            prop: "onlinePrice_table",
            sortable: "custom",
            minWidth: 110,
            formatter: (row) => this.formatTeacherFee(row.onlinePrice),
          },
          {
            label: "授课领域",
            prop: "field_table",
            search: false,
            minWidth: 140,
            formatter: (row) => this.formatListDisplayValue(row.field),
          },
          {
            label: "合作属性",
            prop: "teacher_type_table",
            search: false,
            minWidth: 110,
            formatter: (row) => this.formatListDisplayValue(row.teacher_type),
          },
          {
            label: "常驻城市",
            prop: "resident_city_table",
            search: false,
            minWidth: 120,
            formatter: (row) => this.formatListDisplayValue(row.resident_city),
          },
          {
            label: "最高学历",
            prop: "educational_table",
            search: false,
            minWidth: 120,
            formatter: (row) => this.formatListDisplayValue(row.educational),
          },
          {
            label: "师资负责人",
            prop: "user_table",
            search: false,
            minWidth: 120,
            formatter: (row) => this.formatPrincipalName(row.user),
          },
          {
            label: "本年优惠价格",
            prop: "limited_time_price_table",
            search: false,
            minWidth: 120,
            formatter: (row) => {
              if (row.limited_time_price === null || row.limited_time_price === undefined || row.limited_time_price === '') return '';
              return '¥' + Number(row.limited_time_price).toLocaleString();
            },
          },
          {
            label: "本年度计划排课目标",
            prop: "year_target_table",
            search: false,
            minWidth: 120,
            formatter: (row) => {
              if (row.year_target === null || row.year_target === undefined || row.year_target === '') return '-';
              return `${Number(row.year_target)}天`;
            },
          },
        ];

        const rankListColumn = [
          {
            label: "讲师姓名",
            prop: "name",
            search: false,
            minWidth: 120,
          },
          {
            label: "本年定课",
            prop: "course_days",
            sortable: "custom",
            minWidth: 110,
            formatter: (row) => formatDays(row.course_days),
          },
          {
            label: "课量目标",
            prop: "course_target",
            sortable: "custom",
            minWidth: 110,
            formatter: (row) => `${Number(row.course_target) || 0}天`,
          },
          {
            label: "销售金额/万",
            prop: "order_amount",
            sortable: "custom",
            minWidth: 130,
            formatter: (row) => formatAmount(row.order_amount),
          },
          {
            label: "实施金额/万",
            prop: "implement_amount",
            sortable: "custom",
            minWidth: 130,
            formatter: (row) => formatAmount(row.implement_amount),
          },
          {
            label: "已实施天数",
            prop: "implement_days",
            sortable: "custom",
            minWidth: 120,
            formatter: (row) => formatDays(row.implement_days),
          },
          {
            label: "待实施天数",
            prop: "un_implement_days",
            sortable: "custom",
            minWidth: 120,
            formatter: (row) => formatDays(row.un_implement_days),
          },
          {
            label: "预约天数",
            prop: "reserve_days",
            sortable: "custom",
            minWidth: 110,
            formatter: (row) => formatDays(row.reserve_days),
          },
          {
            label: "已回款/万",
            prop: "received_amount",
            sortable: "custom",
            minWidth: 120,
            formatter: (row) => formatAmount(row.received_amount),
          },
          {
            label: "未回款/万",
            prop: "remain_amount",
            sortable: "custom",
            minWidth: 120,
            formatter: (row) => formatAmount(row.remain_amount),
          },
          {
            label: "目标差",
            prop: "diff_target",
            sortable: "custom",
            minWidth: 110,
            formatter: (row) => formatDays(row.diff_target),
          },
          {
            label: "负责人",
            prop: "user_table",
            minWidth: 120,
            formatter: (row) => this.formatPrincipalName(row.user),
          },
          {
            label: "本年优惠价格",
            prop: "limited_time_price_table",
            search: false,
            minWidth: 120,
            formatter: (row) => {
              if (row.limited_time_price === null || row.limited_time_price === undefined || row.limited_time_price === '') return '';
              return '¥' + Number(row.limited_time_price).toLocaleString();
            },
          },
          {
            label: "本年度计划排课目标",
            prop: "year_target_table",
            search: false,
            minWidth: 120,
            formatter: (row) => {
              if (row.year_target === null || row.year_target === undefined || row.year_target === '') return '-';
              return `${Number(row.year_target)}天`;
            },
          },
          {
            label: "签约日期",
            prop: "contractDate_table",
            search: false,
            type: "daterange",
            searchRange: true,
            searchSpan: 6,
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            startPlaceholder: "日期开始范围自定义",
            endPlaceholder: "日期结束范围自定义",
            hide: true,
            showColumn: false,
          },
        ];

        const riskyEditProps = new Set([]);
        const filterSafeGroupColumns = (columns = []) =>
          stabilizeEditDialog
            ? columns.filter((column) => !riskyEditProps.has(column.prop))
            : columns;
        const teacherGroups = [
          {
            label: "讲师简介",
            prop: "group_intro",
            column: filterSafeGroupColumns(introColumn),
          },
          {
            label: "基础信息",
            prop: "group_basic",
            icon: "el-icon-user",
            column: filterSafeGroupColumns(basicColumn),
          },
          {
            label: "讲师报价",
            prop: "group_quote",
            icon: "el-icon-money",
            column: quoteColumn,
          },
          {
            label: "课程大纲",
            prop: "group_syllabus",
            icon: "el-icon-notebook-2",
            column: [
              {
                label: "",
                prop: "courseOutline",
                formslot: true,
                span: 24,
                labelWidth: 0,
              }
            ]
          },
          {
            label: "授课照片",
            prop: "group_photos",
            icon: "el-icon-picture",
            column: [
              {
                label: "",
                prop: "trainingPhotos",
                formslot: true,
                span: 24,
                labelWidth: 0,
              }
            ]
          },
          {
            label: "授课视频",
            prop: "group_videos",
            icon: "el-icon-video-camera",
            column: [
              {
                label: "",
                prop: "teachingVideo",
                formslot: true,
                span: 24,
                labelWidth: 0,
              }
            ]
          },
          {
            label: "公开照片",
            prop: "group_public_photos",
            icon: "el-icon-picture-outline",
            column: [
              {
                label: "",
                prop: "publicPhotos",
                formslot: true,
                span: 24,
                labelWidth: 0,
              }
            ]
          }
        ];

          return {
            border: true,
            addBtn: false,
            dialogWidth: "85%",
            menuWidth: this.isMobile ? 120 : 300,
            menuFixed: !this.isMobile ? "right" : false,
            menuAlign: "center",
            viewBtn: true,
            align: "center",
            searchShow: false,
            searchBtn: false,
            emptyBtn: false,
            searchMenuSpan: 4,
            editBtn: isHide,
            delBtn: isHide,
            dialogClickModal: false,
            index: !this.isMobile,
            indexLabel: "序号",
            tabs: true,
            translate: false,
            column: (this.useDefaultFields ? listColumn : rankListColumn).map((column) => ({
              ...column,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
            })),
            group: stabilizeEditDialog
              ? teacherGroups
              : [
                  {
                    label: "讲师简介",
                    prop: "group_intro",
                    column: introColumn
                  },
                  {
                    label: "基础信息",
                    prop: "group_basic",
                    icon: "el-icon-user",
                    column: basicColumn
                  },
                  {
                    label: "讲师报价",
                    prop: "group_quote",
                    icon: "el-icon-money",
                    column: quoteColumn
                  },
                  {
                    label: "课程大纲",
                    prop: "group_syllabus",
                    icon: "el-icon-notebook-2",
                    column: [
                      {
                        label: "",
                        prop: "courseOutline",
                        formslot: true,
                        span: 24,
                        labelWidth: 0,
                      }
                    ]
                  },
                  {
                    label: "授课照片",
                    prop: "group_photos",
                    icon: "el-icon-picture",
                    column: [
                      {
                        label: "",
                        prop: "trainingPhotos",
                        formslot: true,
                        span: 24,
                        labelWidth: 0,
                      }
                    ]
                  },
                  {
                    label: "授课视频",
                    prop: "group_videos",
                    icon: "el-icon-video-camera",
                    column: [
                      {
                        label: "",
                        prop: "teachingVideo",
                        formslot: true,
                        span: 24,
                        labelWidth: 0,
                      }
                    ]
                  },
                  {
                    label: "公开照片",
                    prop: "group_public_photos",
                    icon: "el-icon-picture-outline",
                    column: [
                      {
                        label: "",
                        prop: "publicPhotos",
                        formslot: true,
                        span: 24,
                        labelWidth: 0,
                      }
                    ]
                  }
                ]
          };
      },

      teachoption() {
        return {
          border: true,
          dialogWidth: 900,
          menuWidth: this.isMobile ? 120 : 280,
          height: "auto",
          menu: false,
          viewBtn: false,
          addBtn: false,
          align: "center",
          searchMenuSpan: 24,
          searchShowBtn: false,
          refreshBtn: false,
          editBtn: false,
          delBtn: false,
          dialogClickModal: false,
          index: true,
          columnBtn: false,
          indexLabel: "序号",
          translate: false,
          column: [
            {
              label: "上课时间",
              prop: "times",
              span: 8,
              slot: true,
              search: true,
              searchslot: true,
              sortable: "custom",
              width: 120,
            },
            {
              label: "讲师",
              prop: "teacher",
              span: 24,
              type: "select",
              slot: true,
              // dicUrl: "teachers/option",
              searchFilterable: true,
              width: 80,
              props: {
                label: "name",
                value: "_id",
              },
            },
            {
              label: "课程名称",
              prop: "post",
              span: 8,
              width: "200px",
              search: true,
              slot: true,
            },

            {
              label: "授课方式",
              prop: "way",
              type: "select",
              span: 24,
              slot: true,
              searchFilterable: true,
              search: true,
              width: 100,
            },
            {
              label: "总时长（小时/天）",
              prop: "fate",
              span: 8,
              width: "150px",
              slot: true,
            },

            {
              label: "授课类别",
              prop: "category",
              props: {
                label: "label",
                value: "label",
              },
              search: true,
              type: "select",
              searchFilterable: true,
              dicUrl: `dictionaries/type/schedule.category`,

              span: 8,
            },

            {
              label: "授课城市",
              slot: true,
              prop: "city",
              filterable: true,
              search: true,
              type: "cascader",
              searchslot: true,
              props: {
                label: "value",
                value: "value",
              },
              span: 8,
              // dicData: this.cities,
              dicUrl: "",
              checkStrictly: false,
            },
            {
              label: "银行类别",
              prop: "bank_type",
              props: {
                label: "label",
                value: "label",
              },
              type: "select",
              dicUrl: `dictionaries/type/schedule.bank_type`,
              span: 8,
              searchFilterable: true,
              hide: true,
              showColumn: false,
              search: true,
            },
            {
              label: "终端名称",
              prop: "terminal_name",
              span: 8,
              showColumn: true,
              search: true,
              slot: true,
            },

            {
              label: "学员岗位",
              prop: "student_job",
              span: 8,
              showColumn: false,
              search: true,
              slot: true,
            },

            {
              label: "客户名称",
              searchFilterable: true,
              prop: "customer",
              slot: true,
              props: {
                label: "name",
                value: "_id",
              },
              span: 8,
              width: "200px",
              search: true,
              type: "select",
              dicUrl: "customers/option",
            },
            {
              label: "满意度",
              prop: "evaluate",
              type: "select",
              props: {
                label: "label",
                value: "value",
              },
              search: true,
              rules: [
                {
                  required: true,
                  message: "请选择满意度",
                  trigger: "blur",
                },
              ],
              span: 8,
              dicUrl: `dictionaries/type/schedule.satisfaction`,
            },

            {
              label: "创建人",
              searchFilterable: true,
              prop: "user",
              slot: true,
              props: {
                label: "realname",
                value: "_id",
              },
              span: 8,
              width: "140px",
              search: true,
              type: "select",
              dicUrl: "users/leader/option",
            },
          ],
        };
      },
      dialogOption() {
        return {
          translate: false,
          column: [
            {
              label: "负责人",
              prop: "user",
              filterable: true,
              props: {
                label: "realname",
                value: "_id",
              },
              type: "tree",
              multiple: true,
              rules: [
                {
                  required: true,
                  message: "请选择负责人",
                  trigger: "blur",
                },
              ],
              span: 24,
              dicUrl: "users/director",
              // dicQuery: {
              //   query: {
              //     limit: 0,
              //   },
              // },
              // dicData: importField,
            },
          ],
        };
      },
      cur_time() {
        return (item) => {
          let times = item.times.filter((v) => dayjs(v).toDate() < new Date()).sort((a, b) => new Date(a) > new Date(b) ? -1 : 1);
          return times.join(",");
        };
      },
    },
    watch: {
      useDefaultFields() {
        this.syncListFiltersByMode();
        this.refreshCrudOption();
      },
      "crudForm.quotation": {
        handler(list) {
          this.syncQuoteTerminalPrice(list);
        },
        deep: true,
        immediate: true,
      },
      "customerQuery.year"() {
        console.log(this.customerQuery.year);
        this.teacherData(this.obj);
        this.fetchDetailData();

        const years = this.customerQuery.year.map((v) => {
          return dayjs(v).format("YYYY-MM");
        });

        let time_str = Array.from(new Set(years)).join("-");
        this.$message({
          message: `已为您切换至${time_str}年数据`,
          type: "success",
          align: "center",
          center: true,
        });
      },
      tabType: {
        handler() {
          this.activeStatsIndex = -1;
          this.statsFilter = null;
          this.page.currentPage = 1;
          this.fetchStats();
          this.fetch();
        }
      },
      currentYear: {
        handler() {
          this.activeStatsIndex = -1;
          this.statsFilter = null;
          this.fetchStats();
          this.fetchNoOrderTeacherCount();
          this.fetchMonthlyAmounts();
          this.page.currentPage = 1;
          this.fetch();
        }
      }
    },
    methods: {
      updateScreenState() {
        if (typeof window === "undefined") {
          return;
        }
        this.isMobile = window.innerWidth <= 768;
      },
      updateTrainingPhotos(value) {
        const nextValue = Array.isArray(value) ? [...value] : [];
        this.$set(this.crudForm, "trainingPhotos", nextValue);
      },
      handleTeacherTypesChange(value) {
        const nextValue = this.normalizeTypesValue(value);
        this.typesFormValue = nextValue;
        this.$set(this.crudForm, "types", nextValue);
      },
      // 官网公开开关:存量讲师库里没有 is_public 键,得用 $set 才触发响应(Vue 2 不追踪新增属性)
      handlePublicChange(checked) {
        this.$set(this.crudForm, "is_public", Number(checked) === 1 ? 1 : 0);
      },
      createDefaultQuotation() {
        return (Array.isArray(this.quotation) ? this.quotation : []).map((item) => ({ ...item }));
      },
      normalizeArrayValue(value) {
        if (Array.isArray(value)) {
          return [...value];
        }
        if (value === undefined || value === null || value === "") {
          return [];
        }
        return [value];
      },
      normalizeUploadValue(value) {
        return this.normalizeArrayValue(value).filter((item) => item !== undefined && item !== null && item !== "");
      },
      normalizeSingleUploadValue(value) {
        if (Array.isArray(value)) {
          return value[0] || "";
        }
        return value || "";
      },
      normalizeDateRangeValue(value) {
        if (!Array.isArray(value)) {
          return [];
        }
        return value
          .filter(Boolean)
          .slice(0, 2)
          .map((item) => {
            if (!item) {
              return "";
            }
            const current = dayjs(item);
            return current.isValid() ? current.format("YYYY-MM-DD") : item;
          });
      },
      normalizeTypesValue(value) {
        if (!Array.isArray(value)) {
          return [];
        }
        return value.map((item) => (Array.isArray(item) ? [...item] : item)).filter((item) => item !== undefined && item !== null && item !== "");
      },
      syncTypesFormValue() {
        this.typesFormValue = this.normalizeTypesValue(this.crudForm.types);
      },
      normalizeQuotationValue(value) {
        if (!Array.isArray(value) || value.length === 0) {
          return this.createDefaultQuotation();
        }
        return value.map((item) => ({
          title: item?.title || "",
          unit: item?.unit || "",
          amount: Number(item?.amount) || 0,
          terminal_price: Number(item?.terminal_price) || 0,
        }));
      },
      normalizeTeacherFormModel(source = {}) {
        const next = {
          ...source,
        };
        
        // Fix infinite update loop in avue-input-number
        const numberFields = ['price', 'onlinePrice', 'limited_time_price', 'year_target', 'recommendedYear'];
        numberFields.forEach(field => {
          if (next[field] === '' || next[field] === null) {
            next[field] = undefined;
          } else if (next[field] !== undefined) {
            next[field] = Number(next[field]);
          }
        });

        next.types = this.normalizeTypesValue(next.types);
        // 授课领域已改为多选(string[]):兼容存量单值字符串/未赋值,统一成数组,
        // 否则 el-select multiple 拿到字符串会渲染异常
        next.field = this.normalizeArrayValue(next.field).filter(Boolean);
        next.contractDate = this.normalizeDateRangeValue(next.contractDate);
        next.cardImage = this.normalizeUploadValue(next.cardImage);
        next.certificate = this.normalizeUploadValue(next.certificate);
        next.photo = this.normalizeUploadValue(next.photo);
        next.avatar = this.normalizeUploadValue(next.avatar);
        next.contract = this.normalizeUploadValue(next.contract);
        next.poster = this.normalizeUploadValue(next.poster);
        next.file = this.normalizeSingleUploadValue(next.file);
        next.attachment = this.normalizeUploadValue(next.attachment);
        next.trainingPhotos = this.normalizeUploadValue(next.trainingPhotos);
        next.quotation = this.normalizeQuotationValue(next.quotation);
        return next;
      },
      syncQuoteTerminalPrice(list = []) {
        if (!Array.isArray(list)) {
          return;
        }
        list.forEach((item) => {
          if (!item) {
            return;
          }
          const amount = Number(item.amount);
          if (Number.isNaN(amount)) {
            return;
          }
          const terminalPrice = amount * 2;
          if (item.terminal_price !== terminalPrice) {
            this.$set(item, "terminal_price", terminalPrice);
          }
        });
      },
      waitForAvueFormStable() {
        return new Promise((resolve) => {
          this.$nextTick(() => {
            setTimeout(resolve, 0);
          });
        });
      },
      scheduleEmbeddedFormsReady() {
        this.embeddedFormsReady = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.embeddedFormsReady = true;
          }, 0);
        });
      },
      getInitialListFilters() {
        return {
          name: "",
          grade: "",
          field: "",
          teacher_type: "",
          resident_city: "",
          educational: "",
          user: "",
          contractDate: [],
        };
      },
      syncListFiltersByMode() {
        if (!Array.isArray(this.listFilters.contractDate)) {
          this.listFilters.contractDate = [];
        }
      },
      buildListFilterWhere() {
        const filters = this.listFilters || {};
        const where = {};
        if (filters.name) {
          where.name = { $regex: filters.name };
        }
        if (filters.grade) {
          where.grade = { $regex: filters.grade };
        }
        if (filters.field) {
          where.field = { $regex: filters.field };
        }
        if (filters.teacher_type) {
          where.teacher_type = { $regex: filters.teacher_type };
        }
        if (filters.resident_city) {
          where.resident_city = { $regex: filters.resident_city };
        }
        if (filters.educational) {
          where.educational = { $regex: filters.educational };
        }
        if (filters.user) {
          where.user = filters.user;
        }
        if (Array.isArray(filters.contractDate) && filters.contractDate.length === 2) {
          where["contractDate.0"] = {
            $gte: filters.contractDate[0],
            $lte: filters.contractDate[1],
          };
        }
        return where;
      },
      handleAdd() {
        this.$refs.crud.rowAdd();
      },
      applyListFilters() {
        this.syncListFiltersByMode();
        this.page.currentPage = 1;
        this.query.page = 1;
        this.query.where = this.buildListFilterWhere();
        this.fetch();
      },
      resetListFilters() {
        this.listFilters = this.getInitialListFilters();
        this.syncListFiltersByMode();
        this.page.currentPage = 1;
        this.query.page = 1;
        this.query.where = {};
        this.fetch();
      },
      normalizeDictionaryOptions(list = []) {
        return (Array.isArray(list) ? list : [])
          .filter((item) => item && item.label)
          .map((item) => ({
            label: item.label,
            value: item.label,
            rawValue: item.value,
            displayName: item.displayName,
          }));
      },
      getTeacherDetailSelect() {
        return [
          "_id",
          "name",
          "types",
          "grade",
          "price",
          "onlinePrice",
          "field",
          "teacher_type",
          "resident_city",
          "educational",
          "user",
          "mobile",
          "email",
          "gender",
          "expert_positioning",
          "content",
          "resume_background",
          "main_courses",
          "teaching_style",
          "service_clients",
          "political_status",
          "has_title",
          "cardName",
          "cardNumber",
          "contact_address",
          "emergencyContact",
          "emergencyCall",
          "bankAccountName",
          "BankNumber",
          "bankName",
          "importantReminder",
          "report_info",
          "annualTeachingGoal",
          "education_info",
          "work_info",
          "cardImage",
          "certificate",
          "photo",
          "avatar",
          "limited_time_price",
          "limited_time_end",
          "quotation",
          "year_target",
          "recommendedYear",
          "address",
          "industry",
          "bookingInfo",
          "contractDate",
          "contract",
          "file",
          "poster",
          "attachment",
          "trainingPhotos",
        ].join(" ");
      },
      getActiveListSort() {
        if (this.query.sort && Object.keys(this.query.sort).length) {
          return this.query.sort;
        }
        if (this.useDefaultFields) {
          return {
            grade: 1,
            name: 1,
          };
        }
        return {};
      },
      getCurrentPageQuery() {
        return {
          page: this.page.currentPage || this.query.page || 1,
          limit: this.page.pageSize || this.query.limit || 10,
        };
      },
      buildDefaultTeacherQuery(extraWhere = {}) {
        const { page, limit } = this.getCurrentPageQuery();
        return {
          page,
          limit,
          year: this.currentYear,
          where: {
            ...(this.query.where || {}),
            ...extraWhere,
          },
          sort: this.getActiveListSort(),
          select: this.getTeacherDetailSelect(),
        };
      },
      async fetchDefaultTeacherRows(statsTeacherIds = []) {
        if (this.statsFilter && !statsTeacherIds.length) {
          return {
            rows: [],
            total: 0,
          };
        }
        const extraWhere = statsTeacherIds.length
          ? {
              _id: {
                $in: statsTeacherIds,
              },
            }
          : {};
        const query = this.buildDefaultTeacherQuery(extraWhere);
        const res = await this.$http.get("teachers", {
          params: {
            query: JSON.stringify(query),
          },
        });
        const rows = Array.isArray(res.data?.data) ? res.data.data : [];
        return {
          rows: rows.map((item) => this.normalizeTeacherFormModel({
            ...item,
            user: this.normalizePrincipalValue(item?.user),
          })),
          total: Number(res.data?.total) || 0,
        };
      },
      isCurrentYearPartnerStats(item) {
        return item?.label === "本年度合作讲师数";
      },
      formatListDisplayValue(value) {
        if (value === null || value === undefined || value === "") {
          return "-";
        }
        if (Array.isArray(value)) {
          const values = value
            .map((item) => this.formatListDisplayValue(item))
            .filter((item) => item && item !== "-");
          return values.length ? values.join("、") : "-";
        }
        if (typeof value === "object") {
          return (
            value.label ||
            value.displayName ||
            value.realname ||
            value.name ||
            value.value ||
            "-"
          );
        }
        return String(value);
      },
      formatTeacherFee(value) {
        if (value === null || value === undefined || value === "") {
          return "-";
        }
        const amount = Number(value);
        if (Number.isNaN(amount)) {
          return this.formatListDisplayValue(value);
        }
        return amount.toLocaleString("zh-CN");
      },
      async fetchTeacherDictionaryOptions() {
        try {
          const [fieldRes, educationalRes, gradeRes, typeRes, typeTreeRes] = await Promise.all([
            this.$http.get("dictionaries/type/schedule.field"),
            this.$http.get("dictionaries/type/teacher.educational"),
            this.$http.get("dictionaries/type/teacher.grade"),
            this.$http.get("dictionaries/type/teacher.type"),
            this.$http.get("teachers/type"),
          ]);
          this.teacherFieldOptions = this.normalizeDictionaryOptions(fieldRes.data);
          this.teacherEducationalOptions = this.normalizeDictionaryOptions(educationalRes.data);
          this.teacherGradeOptions = this.normalizeDictionaryOptions(gradeRes.data);
          this.teacherTypeOptions = this.normalizeDictionaryOptions(typeRes.data);
          this.teacherTypeTreeOptions = Array.isArray(typeTreeRes.data) ? typeTreeRes.data : [];
        } catch (error) {
          console.error(error);
          this.$message.error("加载讲师字典数据失败");
        } finally {
          this.refreshCrudOption();
        }
      },
      refreshCrudOption() {
        this.crudOption = this.option;
      },
      flattenUserOptions(list = []) {
        const result = [];
        const walk = (items) => {
          (Array.isArray(items) ? items : []).forEach((item) => {
            if (!item) {
              return;
            }
            result.push(item);
            if (Array.isArray(item.children) && item.children.length) {
              walk(item.children);
            }
          });
        };
        walk(list);
        return result;
      },
      async fetchPrincipalUsers() {
        try {
          const [leaderRes, specialistRes] = await Promise.allSettled([
            this.$http.get("users/leader/option"),
            this.$http.get("users/specialist/option"),
          ]);
          const userMap = {};
          const allUsers = [];
          // principalUserMap 从两个来源填充，用于表格/弹窗显示
          [leaderRes, specialistRes].forEach((res) => {
            if (res.status !== "fulfilled") {
              return;
            }
            this.flattenUserOptions(res.value?.data).forEach((item) => {
              const id = item?._id || item?.value || item?.id;
              const name =
                item?.realname || item?.name || item?.label || item?.displayName || item?.username;
              if (id && name) {
                userMap[String(id)] = name;
              }
            });
          });
          this.principalUserMap = userMap;
          // 下拉过滤选项仅使用师资专员（role 10）
          if (specialistRes.status === "fulfilled") {
            this.flattenUserOptions(specialistRes.value?.data).forEach((item) => {
              allUsers.push(item);
            });
          }
          this.principalUserOptions = allUsers;
        } catch (error) {
          console.error(error);
        }
      },
      async ensurePrincipalUsersLoaded() {
        if (Object.keys(this.principalUserMap || {}).length) {
          return;
        }
        await this.fetchPrincipalUsers();
      },
      normalizePrincipalValue(value) {
        if (!value) {
          return value;
        }
        if (Array.isArray(value)) {
          return value.map((item) => this.normalizePrincipalValue(item));
        }
        if (typeof value === "object") {
          const id = value._id || value.value || value.id;
          const mappedName = id ? this.principalUserMap[String(id)] : "";
          if (value.realname || value.name || value.label || value.username) {
            return value;
          }
          if (mappedName) {
            return {
              ...value,
              _id: id,
              realname: mappedName,
            };
          }
          return value;
        }
        const mappedName = this.principalUserMap[String(value)];
        if (mappedName) {
          return {
            _id: value,
            realname: mappedName,
          };
        }
        return value;
      },
      getTeacherId(row) {
        return row?.id || row?._id || row?.__rankId || null;
      },
      getValueByPath(row, path) {
        if (!row || !path) {
          return undefined;
        }
        return String(path)
          .split(".")
          .reduce((acc, key) => {
            if (acc === null || acc === undefined) {
              return undefined;
            }
            if (Array.isArray(acc) && /^\d+$/.test(key)) {
              return acc[Number(key)];
            }
            return acc[key];
          }, row);
      },
      normalizeComparableValue(value) {
        if (value === null || value === undefined) {
          return "";
        }
        if (value instanceof Date) {
          return value.getTime();
        }
        if (Array.isArray(value)) {
          return value.map((item) => this.normalizeComparableValue(item)).join(",");
        }
        if (typeof value === "object") {
          if (value._id) {
            return String(value._id);
          }
          if (value.realname) {
            return value.realname;
          }
          if (value.name) {
            return value.name;
          }
          return JSON.stringify(value);
        }
        return value;
      },
      formatPrincipalName(value) {
        if (!value) {
          return "-";
        }
        if (Array.isArray(value)) {
          const names = value
            .map((item) => this.formatPrincipalName(item))
            .filter((item) => item && item !== "-");
          return names.length ? names.join("、") : "-";
        }
        if (typeof value === "object") {
          return value.realname || value.name || value.label || value.username || "-";
        }
        return String(value);
      },
      compareFilterValue(sourceValue, conditionValue) {
        const left = this.normalizeComparableValue(sourceValue);
        const right = this.normalizeComparableValue(conditionValue);
        const leftDate = new Date(left).getTime();
        const rightDate = new Date(right).getTime();
        const canUseDate = !Number.isNaN(leftDate) && !Number.isNaN(rightDate);
        if (canUseDate) {
          return leftDate - rightDate;
        }
        const leftNumber = Number(left);
        const rightNumber = Number(right);
        const canUseNumber = !Number.isNaN(leftNumber) && !Number.isNaN(rightNumber);
        if (canUseNumber) {
          return leftNumber - rightNumber;
        }
        if (left === right) {
          return 0;
        }
        return String(left).localeCompare(String(right), "zh-CN");
      },
      matchesCondition(sourceValue, condition) {
        if (condition && typeof condition === "object" && !Array.isArray(condition)) {
          if (Object.prototype.hasOwnProperty.call(condition, "$regex")) {
            const keyword = String(condition.$regex || "").toLowerCase();
            if (Array.isArray(sourceValue)) {
              return sourceValue.some((item) =>
                String(this.normalizeComparableValue(item)).toLowerCase().includes(keyword)
              );
            }
            return String(this.normalizeComparableValue(sourceValue)).toLowerCase().includes(keyword);
          }
          if (Object.prototype.hasOwnProperty.call(condition, "$in")) {
            const expectValues = (condition.$in || []).map((item) =>
              String(this.normalizeComparableValue(item))
            );
            if (Array.isArray(sourceValue)) {
              return sourceValue.some((item) =>
                expectValues.includes(String(this.normalizeComparableValue(item)))
              );
            }
            return expectValues.includes(String(this.normalizeComparableValue(sourceValue)));
          }
          if (
            Object.prototype.hasOwnProperty.call(condition, "$gte") ||
            Object.prototype.hasOwnProperty.call(condition, "$lte")
          ) {
            if (
              Object.prototype.hasOwnProperty.call(condition, "$gte") &&
              this.compareFilterValue(sourceValue, condition.$gte) < 0
            ) {
              return false;
            }
            if (
              Object.prototype.hasOwnProperty.call(condition, "$lte") &&
              this.compareFilterValue(sourceValue, condition.$lte) > 0
            ) {
              return false;
            }
            return true;
          }
        }

        if (Array.isArray(sourceValue)) {
          return sourceValue.some(
            (item) =>
              String(this.normalizeComparableValue(item)) ===
              String(this.normalizeComparableValue(condition))
          );
        }

        return (
          String(this.normalizeComparableValue(sourceValue)) ===
          String(this.normalizeComparableValue(condition))
        );
      },
      matchesFilterObject(row, filter) {
        if (!filter || !Object.keys(filter).length) {
          return true;
        }

        return Object.entries(filter).every(([key, condition]) => {
          if (key === "$and") {
            return (condition || []).every((item) => this.matchesFilterObject(row, item));
          }
          if (key === "$or") {
            return (condition || []).some((item) => this.matchesFilterObject(row, item));
          }
          const sourceValue = this.getValueByPath(row, key);
          return this.matchesCondition(sourceValue, condition);
        });
      },
      applyTabTypeFilter(rows) {
        if (this.tabType !== "new_signed") {
          return rows;
        }
        const start = dayjs(`${this.currentYear}-01-01`).startOf("year").toDate();
        const end = dayjs(`${this.currentYear}-01-01`).endOf("year").toDate();
        return rows.filter((row) => {
          const contractDate = this.getValueByPath(row, "contractDate.0");
          if (!contractDate) {
            return false;
          }
          const current = new Date(contractDate);
          if (Number.isNaN(current.getTime())) {
            return false;
          }
          return current >= start && current <= end;
        });
      },
      applyLocalSort(rows) {
        const sortEntries = Object.entries(this.getActiveListSort() || {}).filter(([, order]) =>
          [1, -1].includes(order)
        );
        if (!sortEntries.length) {
          return rows;
        }
        return [...rows].sort((left, right) => {
          for (const [key, order] of sortEntries) {
            const result = this.compareFilterValue(
              this.getValueByPath(left, key),
              this.getValueByPath(right, key)
            );
            if (result !== 0) {
              return order === -1 ? -result : result;
            }
          }
          return 0;
        });
      },
      isDateInRange(value, start, end) {
        if (!value) {
          return false;
        }
        const current = new Date(value);
        if (Number.isNaN(current.getTime())) {
          return false;
        }
        return current >= new Date(start) && current <= new Date(end);
      },
      hasDateRangeMatch(row, field, start, end) {
        const sourceValue = this.getValueByPath(row, field);
        if (Array.isArray(sourceValue)) {
          return sourceValue.some((item) => this.isDateInRange(item, start, end));
        }
        return this.isDateInRange(sourceValue, start, end);
      },
      applyStatsFilter(rows, statsFilter) {
        if (!statsFilter) {
          return rows;
        }

        const filter = typeof statsFilter === "string" ? JSON.parse(statsFilter) : statsFilter;
        if (!filter?.type) {
          return rows.filter((row) => this.matchesFilterObject(row, filter));
        }

        switch (filter.type) {
          case "date_range":
            return rows.filter((row) =>
              this.hasDateRangeMatch(row, filter.field, filter.start, filter.end)
            );
          case "recommended_year":
            return rows.filter((row) => Number(row.recommendedYear) === Number(filter.year));
          case "schedule_exists":
            return rows.filter(
              (row) => (Number(row.course_days) || 0) > 0 || (Number(row.online_course_hours) || 0) > 0
            );
          case "schedule_days":
            return rows.filter((row) => (Number(row.course_days) || 0) > 0);
          case "schedule_hours":
            return rows.filter((row) => (Number(row.online_course_hours) || 0) > 0);
          case "new_signed_schedule_days":
            return rows.filter(
              (row) =>
                this.hasDateRangeMatch(row, "contractDate.0", filter.start, filter.end) &&
                (Number(row.course_days) || 0) > 0
            );
          case "new_signed_schedule_hours":
            return rows.filter(
              (row) =>
                this.hasDateRangeMatch(row, "contractDate.0", filter.start, filter.end) &&
                (Number(row.online_course_hours) || 0) > 0
            );
          case "new_signed_schedule":
            return rows.filter(
              (row) =>
                this.hasDateRangeMatch(row, "contractDate.0", filter.start, filter.end) &&
                (Number(row.total_order_amount) || 0) > 0
            );
          case "no_order":
            return rows.filter(
              (row) =>
                !(Number(row.course_days) || 0) &&
                !(Number(row.online_course_hours) || 0) &&
                !(Number(row.total_order_amount) || 0)
            );
          default:
            return rows.filter((row) => this.matchesFilterObject(row, filter));
        }
      },
      async fetchTeacherRankRows(way = 1, sort = this.query.sort || {}) {
        const res = await this.$http.post("home/teacher_day", {
          way,
          sort,
          wayrankYear: dayjs(`${this.currentYear}-01-01`).toDate(),
        });
        return Array.isArray(res.data) ? res.data : [];
      },
      async fetchTeacherDetails(ids, select = this.getTeacherDetailSelect()) {
        if (!ids.length) {
          return [];
        }
        const res = await this.$http.get("teachers", {
          params: {
            query: JSON.stringify({
              page: 1,
              limit: ids.length,
              where: {
                _id: {
                  $in: ids,
                },
              },
              sort: {},
              select,
            }),
          },
        });
        return res.data?.data || [];
      },
      async fetchStatsFilterTeacherIds(statsFilter) {
        if (!statsFilter) {
          return [];
        }
        const filter = typeof statsFilter === "string" ? JSON.parse(statsFilter) : statsFilter;
        const res = await this.$http.post("teachers/statistics/filter-ids", {
          filter,
          tabType: this.tabType,
          year: Number(this.currentYear || dayjs().year()),
        });
        return Array.isArray(res.data) ? res.data : [];
      },
      mapRankTeacherRow(rankRow, teacherRow, onlineRankRow = {}) {
        const offlineRankRow = rankRow || {};
        const onlineCourseDays = Number(onlineRankRow.course_days) || 0;
        const onlineOrderAmount = Number(onlineRankRow.order_amount) || 0;
        const onlineImplementAmount = Number(onlineRankRow.implement_amount) || 0;
        const normalizedUser = this.normalizePrincipalValue(teacherRow?.user);
        return this.normalizeTeacherFormModel({
          ...(teacherRow || {}),
          _id: teacherRow?._id || offlineRankRow._id || onlineRankRow._id,
          id: teacherRow?.id || teacherRow?._id || offlineRankRow._id || onlineRankRow._id,
          __rankId: offlineRankRow._id || onlineRankRow._id,
          name: offlineRankRow.name || onlineRankRow.name || teacherRow?.name || "",
          user: normalizedUser,
          course_days: Number(offlineRankRow.course_days) || 0,
          course_target: Number(offlineRankRow.course_target) || 0,
          order_amount: Number(offlineRankRow.order_amount) || 0,
          implement_amount: Number(offlineRankRow.implement_amount) || 0,
          implement_days: Number(offlineRankRow.implement_days) || 0,
          un_implement_days: Number(offlineRankRow.un_implement_days) || 0,
          reserve_days: Number(offlineRankRow.reserve_days) || 0,
          received_amount: Number(offlineRankRow.received_amount) || 0,
          remain_amount: Number(offlineRankRow.remain_amount) || 0,
          diff_target: Number(offlineRankRow.diff_target) || 0,
          online_course_days: onlineCourseDays,
          online_course_hours: onlineCourseDays * 6,
          online_order_amount: onlineOrderAmount,
          online_implement_amount: onlineImplementAmount,
          total_order_amount: (Number(offlineRankRow.order_amount) || 0) + onlineOrderAmount,
        });
      },
      async fetchNoOrderTeacherCount() {
        this.noOrderLoading = true;
        this.noOrderError = false;
        try {
          const year = this.currentYear || new Date().getFullYear();
          const res = await this.$http.get(`teachers/statistics/no-order-count`, { params: { year } });
          this.noOrderTeacherCount = res.data?.count ?? res.data?.data ?? res.data ?? 0;
        } catch (error) {
          console.error(error);
          this.noOrderError = true;
          this.$message.error("获取未成单讲师数量失败");
        } finally {
          this.noOrderLoading = false;
        }
      },
      async fetchMonthlyAmounts() {
        try {
          const year = this.currentYear || new Date().getFullYear();
          const res = await this.$http.get('teachers/monthly-amounts', { params: { year } });
          const data = res.data || {};
          this.monthlyStatAmountMap = {
            delivery: data.delivery || {},
            sales: data.sales || {},
          };
        } catch (error) {
          console.error(error);
          this.$message.error('获取月度金额数据失败');
          this.monthlyStatAmountMap = {};
        }
      },
      getMonthlyStatAmount(type, month) {
        const amount = this.monthlyStatAmountMap?.[type]?.[month] ?? 0;
        return Number(amount).toFixed(2);
      },

      handleStatsClick(item, index) {
        if (this.activeStatsIndex === index) {
          this.activeStatsIndex = -1;
          this.statsFilter = null;
          this.useDefaultFields = true;
          this.query.sort = {};
        } else {
          this.activeStatsIndex = index;
          this.statsFilter = JSON.stringify(item.filter);
          this.useDefaultFields = !this.isCurrentYearPartnerStats(item);
          if (this.isCurrentYearPartnerStats(item)) {
            this.query.sort = { course_days: -1 };
          } else {
            this.query.sort = {};
          }
        }
        this.refreshCrudOption();
        this.page.currentPage = 1;
        this.fetch();
      },
      handleNoOrderStatsClick() {
        if (this.activeStatsIndex === "no_order") {
          this.activeStatsIndex = -1;
          this.statsFilter = null;
        } else {
          this.activeStatsIndex = "no_order";
          this.statsFilter = JSON.stringify({
            type: "no_order",
            year: Number(this.currentYear || dayjs().year()),
          });
        }
        this.useDefaultFields = true;
        this.refreshCrudOption();
        this.page.currentPage = 1;
        this.fetch();
      },
      handleClose(done) {
        done();
      },
      resetPrincipalForm() {
        this.principalForm = {
          _id: "",
          name: "",
          user: [],
        };
      },
      handlePrincipalClose(done) {
        done();
        this.resetPrincipalForm();
      },
      async fetchStats() {
        this.statsLoading = true;
        try {
          const res = await this.$http.get('teachers/statistics', {
            params: {
              year: this.currentYear,
              tabType: this.tabType
            }
          });
          this.statsData = res.data;
        } catch (e) {
          this.$message.error("获取统计数据失败");
        } finally {
          this.statsLoading = false;
        }
      },
      async submit(row, done) {
        const payload = {
          _id: this.principalForm._id,
          user: Array.isArray(this.principalForm.user) ? [...this.principalForm.user] : [],
        };
        await this.$http.put(`teachers/${payload._id}`, payload);
        this.$message.success("提交成功");
        this.fetch();
        done();
        this.dialogPrincipal = false;
        this.resetPrincipalForm();
      },
      getIcon(name) {
        const map = {
          'user-group': 'el-icon-s-custom',
          'calendar-check': 'el-icon-date',
          'clock': 'el-icon-time',
          'file-text': 'el-icon-document',
          'user-plus': 'el-icon-circle-plus',
          'briefcase': 'el-icon-suitcase',
          'video': 'el-icon-video-camera',
          'money': 'el-icon-money',
          'target': 'el-icon-aim',
          'trending-up': 'el-icon-top',
          'flag-checkered': 'el-icon-s-flag',
          'star': 'el-icon-star-on'
        };
        return map[name] || 'el-icon-info';
      },
      formatValue(item) {
        if (item.format) {
           return '¥' + Number(item.value).toLocaleString();
        }
        return item.value;
      },
      getChangeColor(change) {
         if (!change) return '';
         if (change.includes('-')) return 'text-success';
         return 'text-danger';
      },
      getChangeIcon(change) {
        if (!change) return '';
        if (change.includes('-')) return 'el-icon-bottom';
        return 'el-icon-top';
      },
      handleCurrentChange(val) {
        this.customerQuery.page = val;
        this.teacherData(this.obj);
      },
      changeDetailPage(val) {
        this.detailPage.page = val;
        this.fetchDetailData();
      },
      sortDetailData(val) {
        const { prop, order } = val;
        this.sort_where = {};

        this.sort_where[prop] = order === "ascending" ? 1 : -1;
        console.log(this.sort_where, "sort_where");
        this.detailPage.page = 1;
        this.fetchDetailData();
      },
      getOssUrl(url) {
        return url + "?x-oss-process=image/resize,w_1000/quality,q_80";
      },
      isRowPrincipal(row) {
        if (!row || !this.user || !this.user._id) return false;
        const userField = row.user;
        if (!userField) return false;

        const currentUserId = String(this.user._id);

        if (Array.isArray(userField)) {
          return userField.some((u) => {
            if (!u) return false;
            return String(u._id || u.value || u.id || u) === currentUserId;
          });
        }

        if (typeof userField === 'object') {
          return String(userField._id || userField.value || userField.id) === currentUserId;
        }

        return String(userField) === currentUserId;
      },
      handleRowEdit(scope) {
        this.$refs.crud.rowEdit(scope.row, scope.index);
      },
      async teachData(row) {
        this.isShowTeach = true;
        this.teach_user = row._id;
        this.fetchTeachList();
      },

      async fetchTeachList() {
        if (!this.teach_user) {
          return false;
        }
        this.teachLoading = true;
        const res = await this.$http.get(
          `teachers/teachList/${this.teach_user}`,
          {
            params: {
              query: {
                where: {
                  times: this.queryTimes,
                  city: this.queryCitys,
                  ...this.teachQuery.where,
                },
                sort: this.teachSort,
                limit: this.teachPage.pageSize,
                page: this.teachPage.currentPage,
              },
            },
          }
        );
        this.teachLoading = false;
        this.teachPage.total = res.data.total;
        this.teachList = res.data.data;
        this.year_evaluate = Number(res.data.year_evaluate).toFixed(2)
      },
      
      async exportTeachList() {
        const { data } = await this.$http.get(
          `teachers/teachList/${this.teach_user}`,
          {
            params: {
              query: {
                where: {
                  times: this.queryTimes,
                  city: this.queryCitys,
                  ...this.teachQuery.where,
                },
                sort: this.teachSort,
                isExport: true,
              },
            },
            responseType: "arraybuffer",
          }
        );
        let blob = new Blob([data], { type: "application/x-xls" });
        saveAs(blob, `${dayjs().format("YYYY-MM-DD")}-授课记录数据.xlsx`);

        this.$message.success("导出成功")
      },
      closeTeach() {
        this.teachExport = false;
        this.teachForm = {
          teachers: [],
          times: []
        }
      },
      async teacherData(row) {
        this.obj = row;
        this.dialogVisible = true;
        const teacherId = this.getTeacherId(row);
        const res = await this.$http.post(`teachers/teacherData/${teacherId}`, {
          params: {
            query: JSON.stringify(this.customerQuery),
          },
        });
        this.customerPage.total = res.data.total;
        this.customers = res.data.cooperativeCustomers;

        this.teachingDay = res.data.teachingDay;
        this.customerCount = res.data.customer;
        this.userData = res.data.userData;
        this.teacherOption = res.data.teacherOption;
        // this.recommendData = res.data.recommend;

        this.teacherOption.data = this.teacherOption.data.map((v) => {
          if (v.key === "remain" || v.key === "receive" || v.key == "amount") {
            return {
              ...v,
              click: function (item) {
                const div_top = document.querySelector(".detail_table");
                if (div_top) {
                  div_top.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              },
            };
          } else {
            return v;
          }
        });
        // this.coach = res.data.coach;
        // console.log(res.data.teachingDays)
        
        // Bank Cooperation Data
        const bankStats = res.data.bankStats || [];
        const onlineData = bankStats.filter(item => item._id.way == 0).map(item => ({ value: item.count, name: item._id.bank }));
        const offlineData = bankStats.filter(item => item._id.way == 1).map(item => ({ value: item.count, name: item._id.bank }));

        this.bankOnlineOption = this.getBankPieOption('线上渠道', onlineData);
        this.bankOfflineOption = this.getBankPieOption('线下渠道', offlineData);

        // Province Cooperation Data
        const provinceStats = res.data.provinceStats || [];
        const onlineProvinceData = provinceStats.filter(item => item._id.way == 0).map(item => ({ value: item.count, name: item._id.province }));
        const offlineProvinceData = provinceStats.filter(item => item._id.way == 1).map(item => ({ value: item.count, name: item._id.province }));

        this.provinceOnlineOption = this.getBankPieOption('线上', onlineProvinceData);
        this.provinceOfflineOption = this.getBankPieOption('线下', offlineProvinceData);

        Promise.all([this.fetchDetailData()]);
        this.initChart1();
      },
      async fetchDetailData() {
        const res = await this.$http.get(
          `teachers/teacherDetailData/${this.getTeacherId(this.obj)}`,
          {
            params: {
              year: this.customerQuery.year,
              sort: this.sort_where,
              // ...(key=='remain'?this.remaindetailPage:this.receiveddetailPage),
              ...this.detailPage,
            },
          }
        );
        this.detailData = res.data.data;
        this.detailPage.total = res.data.total;
      },
      handleTeacherClose() {
        this.isShowTeach = false;
      },
      getCurrentTeacherName() {
        return this.crudForm?.teacherName || this.crudForm?.name || this.obj.teacherName || this.obj.name || "讲师";
      },
      sanitizeFilename(name) {
        return String(name || "讲师").replace(/[\\/:*?"<>|]/g, "_").trim() || "讲师";
      },
      formatFolderDate(times) {
        if (!times) return "未知日期";
        const list = Array.isArray(times) ? times : String(times).split(",");
        if (!list.length) return "未知日期";
        return dayjs(list[0]).format("YYYY-MM-DD");
      },
      getOriginalFilename(url) {
        if (!url) return `photo_${Date.now()}.jpg`;
        const cleanUrl = url.split("?")[0];
        return decodeURIComponent(cleanUrl.split("/").pop() || `photo_${Date.now()}.jpg`);
      },
      async fetchPhotoBuffer(url) {
        let targetUrl = url;
        if (targetUrl && !targetUrl.includes("https")) {
          targetUrl = targetUrl.replace("http:", "https:");
        }
        const response = await fetch(targetUrl);
        if (!response.ok) {
          throw new Error("fetch photo failed");
        }
        return response.arrayBuffer();
      },
      async batchDownloadTeachingPhotos() {
        const loading = this.$loading({
          lock: true,
          text: "正在打包，请稍候...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          const teacherName = this.sanitizeFilename(this.getCurrentTeacherName());
          const teacherId = this.crudForm?._id;
          if (!teacherId) {
            throw new Error("no teacher id");
          }
          const { data } = await this.$http.post("/teachers/batch/exports", {
            teacherIds: [teacherId],
          });
          const teacherList = Array.isArray(data) ? data : [];
          // 收集所有带客户名和日期的照片分组
          const photoGroups = teacherList.reduce((list, teacher) => {
            const groups = Array.isArray(teacher?.photos) ? teacher.photos : [];
            groups.forEach((group) => {
              const sources = Array.isArray(group?.sources) ? group.sources : [];
              if (sources.length > 0) {
                list.push({
                  terminal_name: group.terminal_name || "未知客户",
                  times: group.times,
                  sources: sources,
                });
              }
            });
            return list;
          }, []);

          if (!photoGroups.length) {
            throw new Error("no photos");
          }

          const zip = new JSZip();
          const teacherFolder = zip.folder(teacherName);
          await Promise.all(
            photoGroups.map(async (group) => {
              // 子文件夹名：客户名_日期
              const customerName = this.sanitizeFilename(group.terminal_name);
              const dateStr = this.formatFolderDate(group.times);
              const folderName = `${customerName}_${dateStr}`;
              const groupFolder = teacherFolder.folder(folderName);

              await Promise.all(
                group.sources.map(async (url) => {
                  const buffer = await this.fetchPhotoBuffer(url);
                  groupFolder.file(this.getOriginalFilename(url), buffer);
                })
              );
            })
          );

          const blob = await zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: {
              level: 6,
            },
          });
          saveAs(blob, `${teacherName}_授课照片_${dayjs().format("YYYY-MM-DD")}.zip`);
        } catch (error) {
          console.error(error);
          this.$message.error("打包失败，请稍后重试");
        } finally {
          loading.close();
        }
      },
      async exportImgs() {
        this.dialogExport = true;
      },
      exportTeachs() {
        this.teachExport = true;
      },
      distribution(scope) {
        let users = [];
        if (scope.row.user) {
          if (Array.isArray(scope.row.user)) {
            users = scope.row.user.map((v) => {
              return (v && v._id) ? v._id : v;
            });
          } else if (typeof scope.row.user === 'object' && scope.row.user._id) {
            users = [scope.row.user._id];
          } else {
            users = [scope.row.user];
          }
        }
        this.principalForm = {
          _id: scope.row._id,
          name: scope.row.name,
          user: users,
        };
        this.dialogPrincipal = true;
      },
      removeUser(scope) {
        this.$confirm("是否确认解除负责人？", "确认操作", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
          beforeClose: async (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              try {
                const row = scope.row;
                // Only send the necessary fields to update.
                // Sending the full 'row' object might include populated fields or extra properties
                // that the backend does not accept, causing the request to fail.
                // Based on the 'submit' method behavior, the backend supports partial updates.
                // The backend expects a single ObjectId or null, not an empty array.
                const updateData = {
                  _id: row._id,
                  user: null
                };
                
                await this.$http.put(`teachers/${row._id}`, updateData);
                this.$message.success("解除成功");
                this.fetch();
                instance.confirmButtonLoading = false;
                done();
              } catch (e) {
                console.error(e);
                this.$message.error("解除失败");
                instance.confirmButtonLoading = false;
                done();
              }
            } else {
              done();
            }
          }
        }).catch(() => {});
      },
      async exprot() {
        const res = await this.$http.post(
          "teachers/export/",
          {},
          {
            responseType: "arraybuffer",
          }
        );
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "application/x-xls" });
        link.href = URL.createObjectURL(blob);
        const title = `${dayjs().format("YYYY")}年客户排课数据`;
        link.download = `${title}.xlsx`;
        link.click();
        document.body.appendChild(link);
      },
      preview(file, column, done) {
        const ext = file.url.split(".").pop();
        if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
          done();
        } else {
          window.open(file.url);
        }
      },
      async loadTrainingPhotos() {
        this.showPhotos = true;
        const res = await this.$http.get(`teachers/training_photo/${this.crudForm._id}`);
        const photos = [];
        res.data.forEach((v) => {
          if (v.training_photos.length > 0) {
            photos.push({
              times: v.times.sort((a, b) => Date.parse(a) - Date.parse(b)),
              url: v.training_photos,
              terminal_name: v.terminal_name,
            });
          }
        });
        this.photos = photos.sort(
          (a, b) =>
            Date.parse(b.times[b.times.length - 1]) -
            Date.parse(a.times[a.times.length - 1])
        );
      },
      beforeClose(done) {
        this.photos = [];
        this.showPhotos = false;
        this.photoReadonly = false;
        this.crudReadonly = false;
        this.embeddedFormsReady = false;
        this.typesFormValue = [];
        done();
      },
      sortChange(column) {
        const sortKey = column.prop;
        const sort_num = column.order == "descending" ? -1 : 1;
        this.teachSort = {
          [sortKey]: sort_num,
        };

        console.log("sort where")

        this.fetchTeachList();
      },
      async beforeOpen(done, type) {
        this.embeddedFormsReady = false;
        this.photoReadonly = type === "view";
        this.crudReadonly = type === "view";
        if (["view", "edit"].includes(type)) {
          this.crudForm = this.normalizeTeacherFormModel(this.crudForm);
          this.syncTypesFormValue();
        }
        if (["view"].includes(type)) {
          this.isNewTeacherForm = false;
          await this.ensurePrincipalUsersLoaded();
          const loading = this.$loading({
            lock: true,
            text: "数据加载中，请稍等～",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          await this.loadTrainingPhotos();
          loading.close();
          done();
          this.scheduleEmbeddedFormsReady();
        } else if (["edit"].includes(type)) {
          this.isNewTeacherForm = false;
          if ([0, 6, 10].includes(this.user.role) || this.isRowPrincipal(this.crudForm)) {
            await this.loadTrainingPhotos();
            done();
            this.scheduleEmbeddedFormsReady();
          } else {
            this.$message.error("无操作权限");
            return;
          }
        } else if (["add"].includes(type)) {
          this.isNewTeacherForm = true;
          this.crudForm = this.normalizeTeacherFormModel({
            ...this.crudForm,
            quotation: this.createDefaultQuotation(),
          });
          this.syncTypesFormValue();
          try {
            const { data } = await this.$http.post("teachers", {});
            this.crudForm = this.normalizeTeacherFormModel({ ...data });
            this.syncTypesFormValue();
            this.$http.post(`teachers/update/record`, data);
            done();
            this.scheduleEmbeddedFormsReady();
          } catch (e) {
            this.$message.error("创建讲师失败");
          }
          return;
        } else {
          if (this.user.role !== 0) {
            this.$message.error("无操作权限");
            return;
          }
          //新增逻辑
          //一定要用setTimeout包裹，由于form组件底层一些机制的设计
          // setTimeout(() => {
          //   this.form.name = "初始化赋值";
          // }, 0);
        }
        if (!["view", "edit"].includes(type)) {
          done();
          this.scheduleEmbeddedFormsReady();
        }
      },
      async doImport() {
        if (this.importData.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: "导入中，请稍后。请勿关闭刷新页面",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          await this.$http.post("teachers/import", this.importData);
          loading.close();
          this.fetch();
          this.$message.success("导入成功");
        } else {
          this.$message.error("上传文件为空");
        }
      },
      async parseItems(e) {
        const file = e.target.files[0];
        const { results } = await this.$Export.xlsx(file);
        this.$message.success("上传成功,请导入");
        const items = results.map((v) => {
          return {
            name: v["讲师姓名"],
            gender: v["性别"],
            teacher_category: v["讲师等级"],
            grade: v["讲师等级"],
            teacher_type: v["合作属性"],
            field: v["授课领域"],
            price: Number(v["讲师课酬"]),
            resident_city: v["常驻城市"],
            address: v["详细地址"],
            mobile: v["手机号码"],
            email: v["邮箱"],
            cardName: v["身份证姓名"],
            cardNumber: v["身份证号码"],
            educational: v["最高学历"],
            industry: v["毕业院校"],
            BankNumber: v["银行卡号"],
            bankName: v["开户行"],
            contractDate: v["签约日期"],
            bookingInfo: v["订票信息"],
            content: v["讲师介绍"],
            user: this.user._id,
          };
        });
        this.importData = items;
      },
      async changPage({ pageSize, currentPage }) {
        this.query.page = currentPage;
        this.query.limit = pageSize;
        this.page.currentPage = currentPage;
        this.page.pageSize = pageSize;
        this.fetch();
      },
      handleRankSortChange({ prop, order }) {
        if (!prop || !order) {
          this.query.sort = {};
        } else {
          this.query.sort = {
            [prop]: order === "descending" ? -1 : 1,
          };
        }
        this.page.currentPage = 1;
        this.fetch();
      },
      async changTeachPage({ pageSize, currentPage }) {
        this.teachPage.currentPage = currentPage;
        this.teachPage.pageSize = pageSize;

        this.fetchTeachList();
      },
      teachSearch(where, done) {
        console.log(where, "where");
        console.log(this.teachQuery);
        if(where.terminal_name){
          where.terminal_name = { $regex: where.terminal_name };
        }

        this.teachQuery.where = {
          ...where,
        };
        console.log(this.teachQuery);
        this.fetchTeachList();
        done();
      },
      async search(where, done) {
        done();
      },
      async fetchTeachers() {
        const res = await this.$http.get("teachers/option");
        this.teachers_options = res.data.map((v) => {
          return {
            label: v.name,
            value: v._id,
          };
        });
      },
      async fetch() {
        this.tableLoading = true;
        try {
          await this.ensurePrincipalUsersLoaded();
          const statsTeacherIds = this.statsFilter
            ? await this.fetchStatsFilterTeacherIds(this.statsFilter)
            : [];

          if (this.useDefaultFields) {
            const { rows, total } = await this.fetchDefaultTeacherRows(statsTeacherIds);
            this.page.total = total;
            this.data = {
              data: rows,
              total,
            };
            return;
          }

          const currentSort = this.getActiveListSort();
          const [rankRows, onlineRankRows] = await Promise.all([
            this.fetchTeacherRankRows(1, currentSort),
            this.fetchTeacherRankRows(0, {}),
          ]);
          const offlineRankMap = rankRows.reduce((result, item) => {
            result[String(item._id)] = item;
            return result;
          }, {});
          const onlineRankMap = onlineRankRows.reduce((result, item) => {
            result[String(item._id)] = item;
            return result;
          }, {});
          const rankTeacherIds = Array.from(
            new Set([...rankRows, ...onlineRankRows].map((item) => item._id).filter(Boolean))
          );
          const teacherRows = this.statsFilter
            ? await this.fetchTeacherDetails(statsTeacherIds, this.getTeacherDetailSelect())
            : await this.fetchTeacherDetails(rankTeacherIds, this.getTeacherDetailSelect());
          const teacherMap = teacherRows.reduce((result, item) => {
            result[String(item._id)] = item;
            return result;
          }, {});

          let mergedRows = [];
          if (this.statsFilter) {
            mergedRows = statsTeacherIds.map((id) =>
              this.mapRankTeacherRow(
                offlineRankMap[String(id)],
                teacherMap[String(id)],
                onlineRankMap[String(id)]
              )
            );
          } else {
            mergedRows = rankRows.map((item) =>
              this.mapRankTeacherRow(
                item,
                teacherMap[String(item._id)],
                onlineRankMap[String(item._id)]
              )
            );
          }

          mergedRows = this.applyTabTypeFilter(mergedRows);

          if (this.query.where && Object.keys(this.query.where).length) {
            mergedRows = mergedRows.filter((row) =>
              this.matchesFilterObject(row, this.query.where)
            );
          }

          mergedRows = this.applyLocalSort(mergedRows);

          const currentPage = this.page.currentPage || this.query.page || 1;
          const pageSize = this.page.pageSize || this.query.limit || 10;
          const startIndex = (currentPage - 1) * pageSize;
          const currentData = mergedRows.slice(startIndex, startIndex + pageSize);

          this.page.total = mergedRows.length;
          this.data = {
            data: currentData,
            total: mergedRows.length,
          };
        } catch (error) {
          console.error(error);
          this.$message.error("获取数据失败，请重试");
        } finally {
          this.tableLoading = false;
        }
      },
      getBankPieOption(title, data) {
        return {
          title: {
            show: false,
            text: title,
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: title,
              type: 'pie',
              radius: '50%',
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
      },
      async initChart1() {
        this.$nextTick(() => {
          let chartDom = this.$refs.chart1;
          let chartDom3 = this.$refs.chart3;
          let bankOnlineDom = this.$refs.bankOnlineChart;
          let bankOfflineDom = this.$refs.bankOfflineChart;
          let provinceOnlineDom = this.$refs.provinceOnlineChart;
          let provinceOfflineDom = this.$refs.provinceOfflineChart;

          if (this.myChart) this.myChart.dispose();
          if (this.myChart3) this.myChart3.dispose();
          if (this.bankOnlineChart) this.bankOnlineChart.dispose();
          if (this.bankOfflineChart) this.bankOfflineChart.dispose();
          if (this.provinceOnlineChart) this.provinceOnlineChart.dispose();
          if (this.provinceOfflineChart) this.provinceOfflineChart.dispose();

          this.myChart = this.$echarts.init(chartDom);
          this.myChart3 = this.$echarts.init(chartDom3);
          this.bankOnlineChart = this.$echarts.init(bankOnlineDom);
          this.bankOfflineChart = this.$echarts.init(bankOfflineDom);
          this.provinceOnlineChart = this.$echarts.init(provinceOnlineDom);
          this.provinceOfflineChart = this.$echarts.init(provinceOfflineDom);

          this.myChart.setOption(this.teachingDay, true);
          this.myChart3.setOption(this.userData, true);
          
          if (this.bankOnlineOption) {
            this.bankOnlineChart.setOption(this.bankOnlineOption, true);
          }
          if (this.bankOfflineOption) {
            this.bankOfflineChart.setOption(this.bankOfflineOption, true);
          }
          if (this.provinceOnlineOption) {
            this.provinceOnlineChart.setOption(this.provinceOnlineOption, true);
          }
          if (this.provinceOfflineOption) {
            this.provinceOfflineChart.setOption(this.provinceOfflineOption, true);
          }

          if (this.resizeHandler) {
            window.removeEventListener("resize", this.resizeHandler);
          }
          this.resizeHandler = () => {
            const previousIsMobile = this.isMobile;
            this.updateScreenState();
            if (previousIsMobile !== this.isMobile) {
              this.refreshCrudOption();
            }
            this.myChart && this.myChart.resize();
            this.myChart3 && this.myChart3.resize();
            this.bankOnlineChart && this.bankOnlineChart.resize();
            this.bankOfflineChart && this.bankOfflineChart.resize();
            this.provinceOnlineChart && this.provinceOnlineChart.resize();
            this.provinceOfflineChart && this.provinceOfflineChart.resize();
          };
          window.addEventListener("resize", this.resizeHandler);
        });
      },
      async remove(row) {
        if ([0, 6].includes(this.user.role)) {
          try {
            await this.$confirm("是否确认删除？");
          } catch (e) {
            return;
          }
          await this.$http.delete(`teachers/${row._id}`);
          this.$message.success("删除成功");
          this.fetch();
        } else {
          this.$message.error("无操作权限");
        }
      },
      async exportSubmit(row, done) {
        if (row.teacherIds.length > 5000) {
          this.$message.error("一次最多可导出10个老师");
         return done();
        } 

        const { data } = await this.$http.post("/teachers/batch/exports", row);
          this.dialogExport = false;

          saver.download(
            data,
            () => {
              this.$message.success("下载成功");
              this.dialogExport = false;
            },
            () => {
              this.$message.error("下载失败,请重试");
            }
          );
          done();
      },
      async teachSubmit(row, done) {
        this.$message.success("提交成功，...正在导出", {
          duration: 500
        })
        const { data } = await this.$http.post("teachers/exportTeachList/all", {
          ...row
        }, {
          responseType: "arraybuffer",
        })
        done()
        let blob = new Blob([data], { type: "application/x-xls" });
        saveAs(blob, `${dayjs().format("YYYY-MM-DD")}-授课记录数据.xlsx`);
        this.$message.success("导出成功")
        this.closeTeach()
      },
      // async exportSubmit(row, done) {
      //   const baseUrl="http://localhost:3122/api/"
      //   const token = localStorage.getItem("token") || "";
      //   const tenant = localStorage.getItem("tenant") || "";
      //   const headers = {
      //     Authorization: "Bearer " + token,
      //     "x-tenant": tenant,
      //   };
      //   await fetch(`${baseUrl}teachers/batch/exports`,row, {
      //     method: "POST",
      //     mode: "cors",
      //     headers,
      //   }).then((res) => {
      //     let contentDisposition = res.headers.get("Content-Disposition");
      //     let fileName = contentDisposition.substring(
      //       contentDisposition.lastIndexOf("=") + 1
      //     );
      //     if (!window.WritableStream) {
      //       streamSaver.WritableStream = WritableStream;
      //       window.WritableStream = WritableStream;
      //     }
      //     const fileStream = streamSaver.createWriteStream(fileName);
      //     const readableStream = res.body;
      //     if (readableStream.pipeTo) {
      //       return readableStream.pipeTo(fileStream);
      //     }
      //     window.writer = fileStream.getWriter();
      //     const reader = res.body.getReader();
      //     console.log(22222)
      //     const pump = () =>
      //       reader
      //         .read()
      //         .then((res) =>
      //           res.done ? writer.close() : writer.write(res.value).then(pump)
      //         );
      //     pump();

      //     console.log("end")

      //   });
      // },

      async fetchCity() {
        const { data } = await this.$http.get("getCity");
        this.cityOptions = data;
      },
      async update(row, index, done) {
        if ([0, 6, 10].includes(this.user.role) || this.isRowPrincipal(this.crudForm)) {
          const payload = {
            ...this.crudForm,
          };
          // 公开照片在页签内即时落库(PublicPhotos 自带上传/删除接口),
          // crudForm 只是列表行快照,随表单整体提交会以旧数组覆盖新数据
          delete payload.publicPhotos;
          this.$clear(payload);
          await this.$http.put(`teachers/${payload._id}`, payload);
          this.$message.success("更新成功");
          this.fetch();
          this.$http.post(`teachers/update/record`, payload);
          done();
        } else {
          this.$message.error("无操作权限");
        }
      },
      async create(row, done) {
        try {
          await this.$http.post("teachers/isExist", row);
          // 同 update():公开照片在页签内即时落库,表单里的 publicPhotos 只是打开时的旧快照
          const payload = { ...row };
          delete payload.publicPhotos;
          const { data } = await this.$http.put(`teachers/${row._id}`, payload);
          this.$http.post(`teachers/update/record`, data);
          this.$message.success("创建成功");
          this.fetch();
          done();
        } catch {
          // done();
        }
      },
    },
    beforeDestroy() {
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }
    },
    created() {
      this.updateScreenState();
      this.refreshCrudOption();
      this.fetchTeacherDictionaryOptions();
      this.fetchPrincipalUsers();
      this.fetch();
      this.fetchCity();
      this.fetchTeachers();
      this.fetchStats();
    },
    mounted() {
      this.fetchNoOrderTeacherCount();
      this.fetchMonthlyAmounts();
    },
  };
</script>

<style>
  .stats-card {
    cursor: pointer;
    transition: all 0.3s;
    margin-top: 12px;
  }
  .stats-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
  .stats-container .stats-card .el-card__body {
    height: 72px;
    display: flex;
    align-items: center;
  }
  .stats-container .stats-card .el-card__body > div {
    width: 100%;
  }
  .stats-card-active {
    border: 1px solid #409EFF !important;
    background-color: #ecf5ff !important;
  }
  .stats-card-static {
    cursor: default;
  }
  .stats-card-static:hover {
    transform: none;
    box-shadow: none;
  }
  .monthly-amount-card {
    border: 1px solid #dcdfe6;
  }
  .monthly-amount-card__content {
    min-height: auto;
  }
  .stats-info {
    flex: 1;
    min-width: 0;
  }
  .monthly-amount-card__info {
    flex: 1;
    min-width: 0;
  }
  .monthly-amount-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 4px;
  }
  .monthly-amount-card__select {
    width: 160px;
    flex-shrink: 0;
  }
  .monthly-amount-card__value {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.1;
    color: #303133;
  }
  .teacher .text-truncate {
    color: #409eff;
  }
  .avue-data-panel .item {
    padding: 0 20px !important;
  }

  .avue-data-panel .item-icon .iconfont {
    font-size: 40px;
  }

  .label-title {
    font-size: 14px;
    color: #606266;
    font-weight: bold;
    padding-bottom: 1rem;
  }

  .el-timeline {
    padding: 0 !important;
  }

  .el-timeline .el-image__inner {
    border-radius: 0.4rem !important;
    border: 1px solid #ccc;
  }

  /* .el-textarea_inner {
  color: #000 !important;
}

.el-input__inner{
  color: #000 !important;
} */

  .avue--view .el-input.is-disabled .el-input__inner {
    color: #000 !important;
    opacity: 1 !important;
    transform: none !important;
    cursor: text !important;
  }

  .avue--view .el-textarea.is-disabled .el-textarea__inner {
    color: #000 !important;
    opacity: 1 !important;
    transform: none !important;
    cursor: text !important;
  }

  .el-dialog__body .avue-data-panel .item {
    margin-bottom: 1rem;
  }

  .teacher-search-panel {
    background: #fff;
  }

  .teacher-search-form .el-form-item {
    margin-bottom: 16px;
  }

  .teacher-search-form .el-form-item__label {
    width: 80px !important;
  }

  .teacher-search-form .el-form-item__content {
    width: calc(100% - 80px);
    margin-left: 80px !important;
  }

  .teacher-search-form .el-date-editor,
  .teacher-search-form .el-select,
  .teacher-search-form .el-input {
    width: 100%;
  }

  .teacher-search-form .el-date-editor--daterange.el-input__inner {
    width: 100% !important;
    max-width: 100%;
    min-width: 0;
  }

  .teacher-search-actions-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .teacher-toolbar-bottom {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .teacher-search-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .teacher-search-btn,
  .teacher-reset-btn {
    min-width: 116px;
    height: 40px;
    font-size: 16px;
    border-radius: 4px;
  }

  .teacher-search-btn {
    background: #409eff;
    border-color: #409eff;
  }

  .teacher-reset-btn {
    color: #606266;
    border-color: #dcdfe6;
    background: #fff;
  }

  .teacher .avue-crud .avue-crud__menu {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    white-space: nowrap;
  }

  .teacher .avue-crud td:last-child .cell,
  .teacher .avue-crud .avue-crud__menu .cell {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    white-space: normal;
  }

  .teacher .avue-crud .avue-crud__menu .el-button {
    margin-left: 4px !important;
    margin-right: 4px;
    margin-bottom: 4px;
    margin-top: 4px;
  }

  .teacher .avue-crud .avue-crud__menu .el-button:last-child {
    margin-right: 4px;
  }

  @media only screen and (max-width: 1200px) {
    .stats-container .el-col {
      width: 50% !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .stats-container {
      display: block;
      padding-left: 10px !important;
      padding-right: 10px;
    }

    .stats-container .el-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    .stats-container .el-col {
      width: 100% !important;
      max-width: 100%;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .stats-container .stats-card {
      margin-top: 10px;
    }

    .stats-container .stats-card .el-card__body {
      height: auto;
      display: block;
    }

    .stats-container .d-flex.align-items-center {
      align-items: flex-start !important;
    }

    .monthly-amount-card__content {
      min-height: auto;
    }

    .monthly-amount-card__header {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      margin-bottom: 8px;
    }

    .monthly-amount-card__select,
    .monthly-amount-card__select .el-input {
      width: 100% !important;
    }

    .teacher-filter-panel {
      padding-right: 10px;
    }

    .teacher-filter-row,
    .teacher-dialog-filter {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start !important;
      align-items: flex-start !important;
    }

    .teacher-filter-row .mr-2,
    .teacher-dialog-filter .mr-2 {
      margin-right: 0 !important;
      margin-bottom: 8px;
    }

    .teacher-filter-row .el-date-editor,
    .teacher-dialog-filter > div {
      width: 100% !important;
    }

    .teacher-tab-group {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .teacher-tab-group .el-radio-button {
      width: 100%;
      margin-bottom: 8px;
    }

    .teacher-tab-group .el-radio-button__inner {
      width: 100%;
      border-left: 1px solid #dcdfe6;
      border-radius: 4px;
      text-align: center;
    }

    .teacher-toolbar {
      flex-wrap: wrap;
      padding: 0 10px;
    }

    .teacher-toolbar-import,
    .teacher-toolbar-item {
      width: 100%;
      margin-left: 0 !important;
    }

    .teacher-toolbar-import {
      padding-left: 0 !important;
    }

    .teacher-toolbar .el-form--inline,
    .teacher-toolbar .el-form--inline .d-flex {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .teacher-toolbar .el-form--inline .d-flex.align-items-center,
    .teacher-toolbar .el-form--inline .ml-2,
    .teacher-toolbar-item .el-button {
      width: 100%;
    }

    .teacher-toolbar .el-form--inline .ml-2 {
      margin-left: 0 !important;
      margin-top: 8px;
    }

    .teacher-toolbar .el-form--inline .el-button,
    .teacher-toolbar-item .el-button {
      width: 100%;
    }

    .teacher-search-actions-col {
      justify-content: stretch;
    }

    .teacher-search-form .el-form-item__label {
      float: none;
      display: block;
      width: 100% !important;
      line-height: 20px;
      margin-bottom: 6px;
      text-align: left;
    }

    .teacher-search-form .el-form-item__content {
      width: 100%;
      margin-left: 0 !important;
    }

    .teacher-search-form .el-date-editor--daterange.el-input__inner,
    .teacher-search-form .el-select,
    .teacher-search-form .el-input {
      width: 100% !important;
    }

    .teacher-search-actions {
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    .teacher-search-btn,
    .teacher-reset-btn {
      width: 100%;
    }

    .teacher .avue-crud .el-table {
      font-size: 12px;
      min-width: 100%;
    }

    .teacher .avue-crud .el-table th,
    .teacher .avue-crud .el-table td {
      padding: 8px 0;
    }

    .teacher .avue-crud .el-table__body-wrapper,
    .teacher .avue-crud .el-table__header-wrapper,
    .teacher .avue-crud .el-table__fixed-body-wrapper {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
    }

    .teacher .avue-crud .avue-crud__menu {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      white-space: normal;
    }

    .teacher .avue-crud td:last-child .cell,
    .teacher .avue-crud .avue-crud__menu .cell {
      justify-content: flex-start;
      flex-wrap: wrap;
      text-align: left;
      white-space: normal;
    }

    .teacher .avue-crud .avue-crud__menu .el-button {
      margin-left: 0 !important;
      margin-right: 0;
    }

    .chart-box {
      flex-wrap: wrap
    }

    .chart-wrapper {
      width: 100% !important;
      margin-right: 0 !important;
      margin-bottom: 10px;
    }

    .chart-box .chart1 {
      width: 100%;
    }

    .chart-box .chart2 {
      width: 100%;
    }

  }
</style>
